<template>
    <v-container class="w-container v-overflow edit_annuncio" style="padding-top:59px">

        <v-row>

            <v-col class='mainCont' style="min-width:100vw;position:fixed;left:0;padding-left:0px;z-index:3">

                <div class="mainTitle" style="
                        background-color: white;
                        color: black;
                        font-weight: bold;
                        padding: 4px;
                        font-size: 10px;
                        min-width:100vw;
                        border-color:#01adff">{{ titolo }}</div>

            </v-col>


        </v-row>

        <v-form style="" v-model="valid" ref="form" lazy-validation>

            <v-row>

                <v-col cols="12" md="12">

                    <v-text-field v-model="ads.title" label="Titolo" id="titolo">
                    </v-text-field>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <!-- <div id="cont_companyid" style="cursor:pointer">
                        <ion-item id="itemCompany"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:black!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Azienda </ion-label>

                            <ion-select id="idcompany" name="idcompany" class='idcompany' cancel-Text="Chiudi"
                                done-Text="" :value="ads.idcompany" interface="action-sheet" disabled readonly>

                                <ion-select-option v-for="item in aziende" :key="item.companyid"
                                    :value='item.companyid'> {{
                                        item.companyname }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div> -->

                    <div>


                        <v-text-field id="azienda" v-model="nomeAzienda" label="Azienda" readonly
                            class="custom-label"></v-text-field>

                        <div class="cl-carica-val">
                            <img src="@/assets/calculator.png" id="btnSelAziendaEditAds" title="Seleziona Valore" />
                        </div>


                    </div>


                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <!-- <div id="cont_contratto" style="cursor:pointer">
                        <ion-item id="itemContratto"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:black!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Tipo Contratto </ion-label>

                            <ion-select id="contratto" name="contratto" class='contratto' cancel-Text="Chiudi"
                                done-Text="" :value="ads.contratto" interface="action-sheet">

                                <ion-select-option v-for="item in contratti" :key="item.contratto"
                                    :value='item.contratto'>
                                    {{ item.descrizione }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div> -->

                    <div>


                        <v-text-field id="tipo_contratto" v-model="nomeTipoContratto" label="Tipo Contratto" readonly
                            class="custom-label"></v-text-field>

                        <div class="cl-carica-val">
                            <img src="@/assets/calculator.png" id="btnSelTipoContrattoEditAds"
                                title="Seleziona Valore" />
                        </div>


                    </div>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <!-- <div id="cont_idstudy" style="cursor:pointer">
                        <ion-item id="itemIdStudy"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:black!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Studi Minimi </ion-label>

                            <ion-select id="idstudy" name="idstudy" class='idstudy' cancel-Text="Chiudi" done-Text=""
                                :value="ads.idstudy" interface="action-sheet">

                                <ion-select-option v-for="item in studiMinimi" :key="item.idstudy"
                                    :value='item.idstudy'> {{
                                        item.description }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div> -->

                    <div>


                        <v-text-field id="tipo_contratto" v-model="nomeStudiMinimi" label="Studi Minimi" readonly
                            class="custom-label"></v-text-field>

                        <div class="cl-carica-val">
                            <img src="@/assets/calculator.png" id="btnSelStudiMinimiEditAds" title="Seleziona Valore" />
                        </div>


                    </div>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <!-- <div id="cont_idtypeworkday" style="cursor:pointer">
                        <ion-item id="itemIdTypeWorkDay"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:black!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Giornata Lavoro Tipo </ion-label>

                            <ion-select id="idtypeworkday" name="idtypeworkday" class='idtypeworkday'
                                cancel-Text="Chiudi" done-Text="" :value="ads.idtypeworkday" interface="action-sheet">

                                <ion-select-option v-for="item in tipoDiLavoro" :key="item.idtypeworkday"
                                    :value='item.idtypeworkday'> {{ item.description }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div> -->

                    <div>


                        <v-text-field id="giornata_lavoro_tipo" v-model="nomeGiornataLavoroTipo"
                            label="Giornata Lavoro Tipo" readonly class="custom-label"></v-text-field>

                        <div class="cl-carica-val">
                            <img src="@/assets/calculator.png" id="btnSelGiornataLavoroTipoEditAds"
                                title="Seleziona Valore" />
                        </div>


                    </div>


                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <!-- <div id="cont_idscope" style="cursor:pointer">
                        <ion-item id="itemIdScope"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:black!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Scopo </ion-label>

                            <ion-select id="idscope" name="idscope" class='idscope' cancel-Text="Chiudi" done-Text=""
                                :value="ads.idscope" interface="action-sheet">

                                <ion-select-option v-for="item in scopo" :key="item.idscope" :value='item.idscope'> {{
                                    item.description }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div> -->

                    <div>


                        <v-text-field id="scopo" v-model="nomeScopo" label="Scopo" readonly
                            class="custom-label"></v-text-field>

                        <div class="cl-carica-val">
                            <img src="@/assets/calculator.png" id="btnSelScopoEditAds" title="Seleziona Valore" />
                        </div>


                    </div>


                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <!-- <div id="cont_idcategory" style="cursor:pointer">
                        <ion-item id="itemIdCategory"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:black!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Categoria </ion-label>

                            <ion-select id="idcategory" name="idcategory" class='idcategory' cancel-Text="Chiudi"
                                done-Text="" :value="ads.idcategory" interface="action-sheet">

                                <ion-select-option v-for="item in categorie" :key="item.idcategory"
                                    :value='item.idcategory'> {{
                                        item.description }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div> -->

                    <div>


                        <v-text-field id="categoria" v-model="nomeCategoria" label="Categoria" readonly
                            class="custom-label"></v-text-field>

                        <div class="cl-carica-val">
                            <img src="@/assets/calculator.png" id="btnSelCategoriaEditAds" title="Seleziona Valore" />
                        </div>


                    </div>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <!-- <div id="cont_idsubcategory" style="cursor:pointer">
                        <ion-item id="itemIdSubCategory"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:black!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Sotto Categoria </ion-label>

                            <ion-select id="idsubcategory" name="idsubcategory" class='idsubcategory'
                                cancel-Text="Chiudi" done-Text="" :value="ads.idsubcategory" interface="action-sheet">

                                <ion-select-option v-for="item in sottocategorie" :key="item.idsubcategory"
                                    :value='item.idsubcategory'> {{
                                        item.description }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div> -->

                    <div>


                        <v-text-field id="sottocategoria" v-model="nomeSottoCategoria" label="Sotto Categoria" readonly
                            class="custom-label"></v-text-field>

                        <div class="cl-carica-val">
                            <img src="@/assets/calculator.png" id="btnSelSottoCategoriaEditAds"
                                title="Seleziona Valore" />
                        </div>


                    </div>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <div id="cont_tipolav" style="cursor:pointer">
                        <ion-item id="itemTipoLav"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:black!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Tipo Lavoro </ion-label>

                            <ion-select id="tipo_lavoro" name="tipo_lavoro" class='tipo_lavoro' cancel-Text="Chiudi"
                                done-Text="" :value="ads.tipo_lavoro" interface="action-sheet">

                                <ion-select-option v-for="item in tipoLavoro" :key="item.id" :value='item.id'>
                                    {{
                                        item.name }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div>

                </v-col>

            </v-row>

            <v-row v-if="viewGiorniPartialRemote">


                <v-col cols="12" md="12">

                    <div id="d_importo"
                        class="v-input v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted">
                        <div class="v-input__control">
                            <div class="v-input__slot">
                                <div class="v-text-field__slot"><label for="input-29"
                                        class="v-label v-label--active theme--light"
                                        style="left: 0px; right: auto; position: absolute">Giorni / Settimana</label>

                                    <vue-autonumeric v-model="valueGG" id="fldNGG"
                                        :options="'integer'"></vue-autonumeric>

                                </div>
                            </div>

                            <div class="v-text-field__details">
                                <div class="v-messages theme--light">
                                    <div class="v-messages__wrapper"></div>
                                </div>
                            </div>

                        </div>
                    </div>

                </v-col>

            </v-row>



            <v-row v-if="viewLocation">

                <v-col cols="12" md="12">

                    <div
                        style="background:#8080808c;height:20px;padding:0;min-width:360px;padding-left:5px;margin-bottom:10px">
                        <div style="font-size:12px;padding-left:11px;padding-top:3px;font-weight:bold">
                            Location
                        </div>
                    </div>

                </v-col>

            </v-row>

            <v-row v-if="viewLocation">

                <v-col cols="12" md="12">

                    <!-- <div id="cont_idregione" style="cursor:pointer">
                        <ion-item id="itemIdRegione"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:black!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Regione </ion-label>

                            <ion-select id="idregione" name="idregione" class='idregione' cancel-Text="Chiudi"
                                done-Text="" :value="ads.idregione" interface="action-sheet">

                                <ion-select-option v-for="item in regioni" :key="item.idregione"
                                    :value='item.idregione'> {{
                                        item.nome }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div> -->

                    <div>


                        <v-text-field id="regione" v-model="nomeRegione" label="Regione" readonly
                            class="custom-label"></v-text-field>

                        <div class="cl-carica-val">
                            <img src="@/assets/calculator.png" id="btnSelRegioneEditAds" title="Seleziona Valore" />
                        </div>


                    </div>

                </v-col>

            </v-row>

            <v-row v-if="viewLocation">

                <v-col cols="12" md="12">

                    <!-- <div id="cont_idprovincia" style="cursor:pointer">
                        <ion-item id="itemIdProvincia"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:black!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Provincia </ion-label>

                            <ion-select id="idprovincia" name="idprovincia" class='idprovincia' cancel-Text="Chiudi"
                                done-Text="" :value="ads.idprovincia" interface="action-sheet">

                                <ion-select-option v-for="item in province" :key="item.idprovincia"
                                    :value='item.idprovincia'> {{
                                        item.nome }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div> -->

                    <div>


                        <v-text-field id="provincia" v-model="nomeProvincia" label="Provincia" readonly
                            class="custom-label"></v-text-field>

                        <div class="cl-carica-val">
                            <img src="@/assets/calculator.png" id="btnSelProvinciaEditAds" title="Seleziona Valore" />
                        </div>


                    </div>

                </v-col>

            </v-row>

            <v-row v-if="viewLocation">

                <v-col cols="12" md="12">

                    <!-- <div id="cont_idcomune" style="cursor:pointer">
                        <ion-item id="itemIdComune"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:black!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Comune </ion-label>

                            <ion-select id="idcomune" name="idcomune" class='idcomune' cancel-Text="Chiudi" done-Text=""
                                :value="ads.idcomune" interface="action-sheet">

                                <ion-select-option v-for="item in comuni" :key="item.idcomune" :value='item.idcomune'>
                                    {{
                                        item.nome }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div> -->

                    <div>


                        <v-text-field id="comune" v-model="nomeComune" label="Comune" readonly
                            class="custom-label"></v-text-field>

                        <div class="cl-carica-val">
                            <img src="@/assets/calculator.png" id="btnSelComuneEditAds" title="Seleziona Valore" />
                        </div>


                    </div>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <v-text-field v-model="ads.durata" label="Durata" id="durata">
                    </v-text-field>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <v-text-field v-model="ads.year_experience" label="Anni di esperienza" id="anni_esperienza">
                    </v-text-field>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <v-text-field v-model="ads.level_work" label="Grado seniority" id="grado_seniority">
                    </v-text-field>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <v-textarea v-model="ads.kwoledge" label="Skill necessari" id="skill_necessari">
                    </v-textarea>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <div id="cont_isurgent" style="cursor:pointer">
                        <ion-item id="itemIsUrgent"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:black!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Urgente </ion-label>

                            <ion-select id="isurgent" name="isurgent" class='isurgent' cancel-Text="Chiudi" done-Text=""
                                :value="ads.isurgent" interface="action-sheet">

                                <ion-select-option v-for="item in urgent" :key="item.id" :value='item.id'>
                                    {{
                                        item.value }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <v-menu v-model="showPicker" :close-on-content-click="false" transitions="scale-transition" offset-y
                        max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="ads.date" label="Data Inizio" id="dateStart" persistent-hint readonly
                                v-on="on">
                            </v-text-field>
                        </template>
                        <v-date-picker v-model="ads.date" no-title @input="handleDataInizioChange" locale="it">
                        </v-date-picker>
                    </v-menu>
                    <div class="cl-del-date">
                        <img src="@/assets/elimina.png" id="btnDelData" title="Cancella" />
                    </div>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <v-menu v-model="showPicker2" :close-on-content-click="false" transitions="scale-transition"
                        offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="ads.expired_date" label="Data Scadenza" id="dateEnd" persistent-hint
                                readonly v-on="on">
                            </v-text-field>
                        </template>
                        <v-date-picker v-model="ads.expired_date" no-title @input="showPicker2 = false" locale="it">
                        </v-date-picker>
                    </v-menu>
                    <div class="cl-del-date-expired">
                        <img src="@/assets/elimina.png" id="btnDelDataScadenza" title="Cancella" />
                    </div>

                </v-col>

            </v-row>










            <v-row>

                <v-col cols="12" md="12">

                    <!-- <div id="cont_detskills" style="cursor:pointer">
                        <ion-item id="itemDetSkill"
                            style="min-width:190px!important;transform: translateX(-6px);margin-top:-24px;margin-bottom:18px">

                            <ion-label
                                style="font-size:11px;color:black!important;cursor:pointer;font-weight:bold;opacity:1"
                                position="floating">Details Skills </ion-label>

                            <ion-select id="detskill" name="detskill" class='detskill' cancel-Text="Chiudi" done-Text=""
                                :value="ads.detskill" interface="action-sheet">

                                <ion-select-option v-for="item in skills" :key="item.name" :value='item.name'>
                                    {{
                                        item.name }}</ion-select-option>

                            </ion-select>
                        </ion-item>
                    </div> -->

                    <div>


                        <v-text-field id="detailed_skill" v-model="nomeDetailedSkill" label="Details Skills" readonly
                            class="custom-label"></v-text-field>

                        <div class="cl-carica-val">
                            <img src="@/assets/calculator.png" id="btnSelDetSkillsEditAds" title="Seleziona Valore" />
                        </div>


                    </div>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <v-list>

                        <v-list-tile v-for="el in skillDetails" :key="el.id">

                            <div style="display:flex!important;height:30px">

                                <div>
                                    <v-checkbox v-model="idSkillsSel" multiple class="cl-checkbox" :value="el.id" />
                                </div>
                                <div>{{ el.name }}</div>

                            </div>

                        </v-list-tile>


                    </v-list>

                </v-col>

            </v-row>

            <v-row>

                <v-col cols="12" md="12">

                    <label style="font-weight:bold;color:black;font-size:11px">Descrizione</label>
                    <textarea id="sec_description" name="sec_description" class="sec_description" autofocus
                        style="width:97%!important;height:400px!important;margin:0 auto"></textarea>

                </v-col>

            </v-row>



        </v-form>

        <div class="contaziende">

            <template>
                <div class="text-center">
                    <v-bottom-sheet v-model="sheetAziende" class="vaziendesheet">
                        <v-sheet class="text-center" height="100vh">
                            <div class="headerSheetAziende" fixed style="position:fixed;">
                                Aziende
                                <v-btn class='closeSheet align_close_sheet' icon @click="sheetAziende = !sheetAziende">
                                    <v-img alt="Close Logo" class="  " contain src="@/assets/btn_cancel3_2recruit.png"
                                        max-width="30" max-height="30" transition="scale-transition"
                                        style="margin-right:20px!important" />
                                </v-btn>

                                <v-toolbar>
                                    <v-text-field hide-details prepend-icon="mdi-magnify" single-line v-model="search">
                                    </v-text-field>

                                </v-toolbar>

                            </div>

                            <v-divider></v-divider>

                            <div class="spacer" style="min-height:72px;"></div>

                            <v-flex xs12 sm12>
                                <v-card>

                                    <v-list-item class="text-left" v-for="item in filteredAziende" :key="item.companyid"
                                        @click="manageClickAziende(item)">

                                        <v-img alt="" src="@/assets/2recr_aziende.png" max-width="24" max-height="24" />

                                        <v-list-item-title class='itemAzienda'>{{ item.companyname }}
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-card>
                            </v-flex>

                            <div style="min-height:170px;height:170px">&nbsp;</div>

                        </v-sheet>
                    </v-bottom-sheet>
                </div>
            </template>

        </div>


        <div class="contpopuptypeenable" style="display:none">

            <template>
                <modal name="popupTypeEnable" :clickToClose="false" :width="365" :height="215">


                    <v-row>

                        <v-col cols="12" md="12" style="margin-top:10px!important;font-weight:bold;margin-left:10px">

                            Annuncio

                        </v-col>

                    </v-row>

                    <v-row>

                        <v-col cols="12" md="12">

                            <v-radio-group v-model="tipoAbilitazione" row>
                                <v-radio label="Disabled" value="D"></v-radio>
                                <v-radio label="Enabled" value="A"></v-radio>
                                <v-radio label="Enabled Featured" value="AF"></v-radio>
                            </v-radio-group>

                        </v-col>

                    </v-row>



                    <v-row>

                        <v-col cols="12" md="12">

                            <div style="display:flex;justify-content:center">

                                <v-img alt="" class="btn-confirm-type-enable" contain
                                    src="@/assets/btn_confirm3_jobmule.png" max-width="30" max-height="30"
                                    style="cursor:pointer" transition="scale-transition" title="Conferma"
                                    @click="btnConfirmTypeEnable" />


                            </div>

                        </v-col>

                    </v-row>

                </modal>
            </template>

        </div>


        <modal-table-selector v-model="openDialog" :title="titleSelectElement" :items="itemList"
            :selected-id="selectedId" @confirm="handleConfirm" @cancel="handleCancel" @refresh="loadData"
            :width="widthWindow" :height="heightWindow" draggable />


    </v-container>
</template>

<script>
import apipianoorario from "../utils/pianoorario/apipianoorario";
import apirisorse from "../utils/risorse/apirisorse";
import apiads from "../utils/ads/apiads";
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue';
import ModalTableSelector from "@/components/ModalTableSelector.vue";
import apisottocategorie from "../utils/sottocategorie/apisottocategorie";

import {
    bus
} from "../main";

import router from ".././router";

export default ({
    async mounted() {

        /*eslint-disable no-undef*/




        console.log("PARAMS: ", this.$route.params.id);

        var pointerVue = this;

        tinymce.remove();

        window.doEventChangeIdProvincia = 1;


        this.cur_id = this.$route.params.id;

        this.initSetupButtons(false);

        if (this.$route.params.id == 0) {

            await this.initInsertAds();

            // Dopo che Vue aggiorna il DOM
            await this.$nextTick();

            this.initSetupButtons(true);

        }

        if (this.$route.params.id > 0) {

            this.titolo = "Modifica Annuncio";


            await this.initEditAds();

            // Dopo che Vue aggiorna il DOM
            await this.$nextTick();

            this.initSetupButtons(true);

        }

        bus.$on("bottomIconClickEvent", (data) => {
            //this.header = data;
            console.log(data);
            switch (data) {

                case "btn_save_annuncio":

                    this.validate();

                    break;

                case "btn_back_annuncio":
                    router.push({
                        path: "/annunci"
                    });
                    break;

                default:
                    break;
            }
        });

        $(document).ready(function () {


            $('body').on('click', '#btnSelDetSkillsEditAds', function (event) {

                console.log(event);


                pointerVue.openPopupDetSkills();


            });

            $('body').on('click', '#btnSelComuneEditAds', function (event) {

                console.log(event);


                pointerVue.openPopupComuni();


            });


            $('body').on('click', '#btnSelProvinciaEditAds', function (event) {

                console.log(event);


                pointerVue.openPopupProvince();


            });

            $('body').on('click', '#btnSelRegioneEditAds', function (event) {

                console.log(event);


                pointerVue.openPopupRegioni();


            });

            $('body').on('click', '#btnSelSottoCategoriaEditAds', function (event) {

                console.log(event);


                pointerVue.openPopupSottocategoria();


            });


            $('body').on('click', '#btnSelGiornataLavoroTipoEditAds', function (event) {

                console.log(event);


                pointerVue.openPopupGiornataLavoroTipo();


            });


            $('body').on('click', '#btnSelStudiMinimiEditAds', function (event) {

                console.log(event);


                pointerVue.openPopupStudiMinimi();


            });


            $('body').on('click', '#btnSelTipoContrattoEditAds', function (event) {

                console.log(event);


                pointerVue.openPopupTipoContratto();


            });


            $('body').on('click', '#btnSelAziendaEditAds', function (event) {

                console.log(event);


                pointerVue.openPopupAziende();


            });



            $('body').on('click', '#btnSelCategoriaEditAds', function (event) {

                console.log(event);


                pointerVue.openPopupCategorie();


            });


            $('body').on('click', '#btnSelScopoEditAds', function (event) {

                console.log(event);


                pointerVue.openPopupScopi();


            });



            $('body').on('blur', '#fldNGG', function (event) {
                console.log(event);


                setTimeout(function () {

                    pointerVue.setupButtons();

                }, 300);

            });

            $('body').on('ionChange', '.tipo_lavoro', function (event) {
                console.log(event);

                pointerVue.viewGiorniPartialRemote = false;

                pointerVue.viewLocation = false;

                pointerVue.ads.tipo_lavoro = this.value;


                if ($(this).val() == "Partial Remote") {

                    pointerVue.viewGiorniPartialRemote = true;

                    pointerVue.viewLocation = true;

                    window.doEventChangeIdProvincia = 1;

                }

                if ($(this).val() == "In Presenza") {

                    pointerVue.viewLocation = true;

                    window.doEventChangeIdProvincia = 1;

                }

                setTimeout(function () {

                    pointerVue.setupButtons();

                }, 300);

            });


            $('body').on('blur', '#dateStart', function (event) {
                console.log(event);

                setTimeout(function () {

                    pointerVue.setupButtons();

                }, 300);

            });

            $('body').on('blur', '#dateEnd', function (event) {
                console.log(event);

                setTimeout(function () {

                    pointerVue.setupButtons();

                }, 300);

            });




            $('body').on('blur', '#titolo', function (event) {
                console.log(event);

                pointerVue.ads.title = this.value;

                pointerVue.setupButtons();

            });


            $('body').on('click', '.cl-del-date-expired', function (event) {
                console.log(event);

                pointerVue.ads.expired_date = null;


            });


            $('body').on('click', '.cl-del-date', function (event) {
                console.log(event);

                pointerVue.ads.date = null;


            });


            $('body').on('click', '.btn-confirm-ral', function (event) {
                console.log(event);

                pointerVue.ricerca_candidato.ral = pointerVue.valoreRAL;

                pointerVue.$root.$children[0].setFieldActive("#d_ral");

                pointerVue.$modal.hide('popupRAL');

            });

            $('body').on('click', '.btn-cancel-ral', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupRAL');

            });


            $('body').on('click', '#d_ral', function (event) {
                console.log(event);

                pointerVue.$modal.show('popupRAL');

            });



            $('body').on('click', '.cl-del-date-nascita', function (event) {
                console.log(event);


                pointerVue.ricerca_candidato.data_nascita = null;



            });



            $('body').on('ionChange', '.detskill', function (event) {
                console.log(event);
                console.log("IONCHANGE_DETSKILL");

                pointerVue.loadDetailsSkills(this.value, pointerVue.ads.idcompany);


            });



            $('body').on('ionChange', '.id_portale_lavoro', function (event) {
                console.log(event);

                pointerVue.ricerca_candidato.id_portale_lavoro = this.value;

                setTimeout(function () {

                    pointerVue.setupButtons();

                }, 300);

            });

            $('body').on('ionChange', '.idcategory', function (event) {
                console.log(event);

                pointerVue.ads.idcategory = this.value;

                pointerVue.setSottoCategorie(this.value);

                setTimeout(function () {

                    pointerVue.setupButtons();

                }, 300);

            });

            $('body').on('ionChange', '.idsubcategory', function (event) {
                console.log(event);

                pointerVue.ads.idsubcategory = this.value;


                setTimeout(function () {

                    pointerVue.setupButtons();

                }, 300);

            });



            $('body').on('ionChange', '.idregione', function (event) {
                console.log(event);

                pointerVue.setProvince(this.value);

            });

            $('body').on('ionChange', '.idprovincia', function (event) {
                console.log(event);
                console.log("IONCHANGE IDPROVINCIA");

                console.log("DOEVENTCHANGEIDPROVINCIA: ", window.doEventChangeIdProvincia);

                if (window.doEventChangeIdProvincia == 1) {
                    pointerVue.setComuni(this.value);
                }

                window.doEventChangeIdProvincia = 1;

            });


            $('body').on('click', '#cont_companyid', function (event) {
                console.log(event);

                pointerVue.sheetAziende = true;

            });

            $('body').on('click', '#cont_departmentid', function (event) {
                console.log(event);

                pointerVue.sheetDipartimento = true;

            });

            $('body').on('click', '#cont_companycustomer', function (event) {
                console.log(event);

                pointerVue.sheetAziendeClienti = true;

            });


            $('body').on('click', '#cont_customer_id', function (event) {
                console.log(event);

                pointerVue.sheetClienti = true;

            });



            $('body').on('click', '#cont_login', function (event) {
                console.log(event);

                pointerVue.sheetUtentiAssociati = true;

            });

            $('body').on('click', '.img_copy', function (event) {
                console.log(event);

                pointerVue.valorePagato = pointerVue.valoreDaPagare;

            });

            $('body').on('click', '.img_copy_rim', function (event) {
                console.log(event);

                pointerVue.valorePagato = pointerVue.valoreRimanente;

            });

            $('body').on('click', '#d_importo', function (event) {
                console.log(event);

                if (!pointerVue.disField) {

                    pointerVue.$modal.show('popupImporto');

                }

            });

            $('body').on('click', '.btn-confirm-importo', function (event) {
                console.log(event);

                pointerVue.pagamento.importo = pointerVue.valoreDaPagare;

                pointerVue.$root.$children[0].setFieldActive("#d_importo");

                pointerVue.$modal.hide('popupImporto');

            });

            $('body').on('click', '.btn-cancel-importo', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupImporto');

            });

            $('body').on('click', '#d_pagato', function (event) {
                console.log(event);

                if (pointerVue.$route.params.id == 0) {

                    pointerVue.$modal.show('popupImportoPagato');

                }

                if (pointerVue.$route.params.id > 0) {

                    pointerVue.$modal.show('popupImportoPagatoRimanente');

                }

            });

            $('body').on('click', '.btn-confirm-importo-pagato', function (event) {
                console.log(event);

                pointerVue.pagamento.importo_pagato = pointerVue.valorePagato;

                pointerVue.$root.$children[0].setFieldActive("#d_pagato");

                pointerVue.$modal.hide('popupImportoPagato');

            });

            $('body').on('click', '.btn-cancel-importo-pagato', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupImportoPagato');

            });

            $('body').on('click', '.btn-confirm-importo-pagato-rimanente', function (event) {
                console.log(event);

                pointerVue.pagamento.importo_pagato = pointerVue.valorePagato;

                pointerVue.$root.$children[0].setFieldActive("#d_pagato");

                pointerVue.$modal.hide('popupImportoPagatoRimanente');

            });

            $('body').on('click', '.btn-cancel-importo-pagato-rimanente', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupImportoPagatoRimanente');

            });


            $('body').on('ionChange', '.has_ticket', function (event) {
                console.log(event);

                console.log("HAS_TICKET VAL: ", this.value)

                pointerVue.risorsa.has_ticket = this.value;

                if (this.value == "S") {

                    pointerVue.viewValTicket = true;

                    if (pointerVue.risorsa.val_ticket == null) {

                        pointerVue.risorsa.val_ticket = "5,29";

                    }

                    if (pointerVue.risorsa.val_ticket == 0) {

                        pointerVue.risorsa.val_ticket = "5,29";

                    }

                    if (pointerVue.risorsa.costo_giornaliero != null) {


                        console.log("COST GIORN: ", parseFloat(pointerVue.formatValue(pointerVue.risorsa.costo_giornaliero)));
                        console.log("VAL TICKET: ", parseFloat(pointerVue.formatValue(pointerVue.risorsa.val_ticket)));


                        pointerVue.risorsa.costo_giornaliero = parseFloat(pointerVue.formatValue(pointerVue.risorsa.costo_giornaliero)) + parseFloat(pointerVue.formatValue(pointerVue.risorsa.val_ticket));


                    }




                }

                if (this.value == "N") {

                    pointerVue.risorsa.costo_giornaliero = parseFloat(pointerVue.formatValue(pointerVue.risorsa.costo_giornaliero)) - parseFloat(pointerVue.formatValue(pointerVue.risorsa.val_ticket));

                    pointerVue.risorsa.val_ticket = null;

                    pointerVue.viewValTicket = false;

                }


            });




            $('#input-file-logo').on('change', function () {

                pointerVue.attachRemove = false;

            });

            $(".lunedi").on("ionChange", function (opt) {
                console.log(opt);

                pointerVue.updateTotal();

            });

            $(".martedi").on("ionChange", function (opt) {
                console.log(opt);

                pointerVue.updateTotal();

            });

            $(".mercoledi").on("ionChange", function (opt) {
                console.log(opt);

                pointerVue.updateTotal();

            });

            $(".giovedi").on("ionChange", function (opt) {
                console.log(opt);

                pointerVue.updateTotal();

            });

            $(".venerdi").on("ionChange", function (opt) {
                console.log(opt);

                pointerVue.updateTotal();

            });

            $(".sabato").on("ionChange", function (opt) {
                console.log(opt);

                pointerVue.updateTotal();

            });

            $(".domenica").on("ionChange", function (opt) {
                console.log(opt);

                pointerVue.updateTotal();

            });


            $('body').on('click', '#d_ferie_ap', function (event) {
                console.log(event);

                pointerVue.$modal.show('popupFerieAP');

            });

            $('body').on('click', '.btn-confirm-ferieap', function (event) {
                console.log(event);

                pointerVue.risorsa.ferie_ap = pointerVue.valoreFerieAP;

                pointerVue.$root.$children[0].setFieldActive("#d_ferie_ap");

                pointerVue.$modal.hide('popupFerieAP');

            });

            $('body').on('click', '.btn-cancel-ferieap', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupFerieAP');

            });

            $('body').on('click', '#d_ferie_ac', function (event) {
                console.log(event);

                pointerVue.$modal.show('popupFerieAC');

            });

            $('body').on('click', '.btn-confirm-ferieac', function (event) {
                console.log(event);

                pointerVue.risorsa.ferie_ac = pointerVue.valoreFerieAC;

                pointerVue.$root.$children[0].setFieldActive("#d_ferie_ac");

                pointerVue.$modal.hide('popupFerieAC');

            });

            $('body').on('click', '.btn-cancel-ferieac', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupFerieAC');

            });

            $('body').on('click', '#d_permessi_ap', function (event) {
                console.log(event);

                pointerVue.$modal.show('popupPermessiAP');

            });

            $('body').on('click', '.btn-confirm-permessiap', function (event) {
                console.log(event);

                pointerVue.risorsa.permessi_ap = pointerVue.valorePermessiAP;

                pointerVue.$root.$children[0].setFieldActive("#d_permessi_ap");

                pointerVue.$modal.hide('popupPermessiAP');

            });

            $('body').on('click', '.btn-cancel-permessiap', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupPermessiAP');

            });

            $('body').on('click', '#d_permessi_ac', function (event) {
                console.log(event);

                pointerVue.$modal.show('popupPermessiAC');

            });

            $('body').on('click', '.btn-confirm-permessiac', function (event) {
                console.log(event);

                pointerVue.risorsa.permessi_ac = pointerVue.valorePermessiAC;

                pointerVue.$root.$children[0].setFieldActive("#d_permessi_ac");

                pointerVue.$modal.hide('popupPermessiAC');

            });

            $('body').on('click', '.btn-cancel-permessiac', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupPermessiAC');

            });

            $('body').on('click', '#d_proroga', function (event) {
                console.log(event);

                pointerVue.$modal.show('popupProroga');

            });

            $('body').on('click', '.btn-confirm-proroga', function (event) {
                console.log(event);

                pointerVue.risorsa.proroga = pointerVue.valoreProroga;

                pointerVue.$root.$children[0].setFieldActive("#d_proroga");

                pointerVue.$modal.hide('popupProroga');

            });

            $('body').on('click', '.btn-cancel-proroga', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupProroga');

            });

            $('body').on('click', '#d_lordomese', function (event) {
                console.log(event);

                pointerVue.$modal.show('popupLordoMese');

            });

            $('body').on('click', '.btn-confirm-lordomese', function (event) {
                console.log(event);

                pointerVue.risorsa.lordo_mese = pointerVue.valoreLordoMese;

                pointerVue.$root.$children[0].setFieldActive("#d_lordomese");

                pointerVue.$modal.hide('popupLordoMese');

            });

            $('body').on('click', '.btn-cancel-lordomese', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupLordoMese');

            });

            $('body').on('click', '#d_diaria', function (event) {
                console.log(event);

                pointerVue.$modal.show('popupDiaria');

            });

            $('body').on('click', '.btn-confirm-diaria', function (event) {
                console.log(event);

                pointerVue.risorsa.diaria = pointerVue.valoreDiaria;

                pointerVue.$root.$children[0].setFieldActive("#d_diaria");

                pointerVue.$modal.hide('popupDiaria');

            });

            $('body').on('click', '.btn-cancel-diaria', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupDiaria');

            });

            $('body').on('click', '#d_tarif_net_h', function (event) {
                console.log(event);

                pointerVue.$modal.show('popupTariffNet');

            });

            $('body').on('click', '.btn-confirm-tnetta', function (event) {
                console.log(event);

                pointerVue.risorsa.tariffa_netto = pointerVue.valoreTariffaNetta;

                pointerVue.$root.$children[0].setFieldActive("#d_tarif_net_h");

                pointerVue.$modal.hide('popupTariffNet');

            });

            $('body').on('click', '.btn-cancel-tnetta', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupTariffNet');

            });

            $('body').on('click', '#d_cost_giorn', function (event) {
                console.log(event);

                pointerVue.$modal.show('popupCostGiorn');

            });

            $('body').on('click', '.btn-confirm-cgiorn', function (event) {
                console.log(event);

                pointerVue.risorsa.costo_giornaliero = pointerVue.valoreCostGiorn;

                pointerVue.$root.$children[0].setFieldActive("#d_cost_giorn");

                pointerVue.$modal.hide('popupCostGiorn');

            });

            $('body').on('click', '.btn-cancel-cgiorn', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupCostGiorn');

            });

            $('body').on('click', '#d_ebadge_pausa', function (event) {
                console.log(event);

                pointerVue.$modal.show('popupEbadgePausa');

            });

            $('body').on('click', '.btn-confirm-ebadgepausa', function (event) {
                console.log(event);

                pointerVue.risorsa.min_pausa = pointerVue.valoreEbadgePausa;

                pointerVue.$root.$children[0].setFieldActive("#d_ebadge_pausa");

                pointerVue.$modal.hide('popupEbadgePausa');

            });

            $('body').on('click', '.btn-cancel-ebadgepausa', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupEbadgePausa');

            });

            $('body').on('ionChange', '.is_ebadge', function (event) {
                console.log(event);


                if (this.value == "S") {

                    pointerVue.showRow1 = true;
                    pointerVue.showRow3 = true;
                    pointerVue.showRow4 = true;
                    pointerVue.showRow5 = true;
                    pointerVue.showRow6 = true;

                }

                if (this.value == "N") {

                    pointerVue.showRow1 = false;
                    pointerVue.showRow2 = false;
                    pointerVue.showRow3 = false;
                    pointerVue.showRow4 = false;
                    pointerVue.showRow5 = false;
                    pointerVue.showRow6 = false;


                }


            });


            $('body').on('ionChange', '.idebadge_type_registration', function (event) {
                console.log(event);


                console.log("VAL: ", this.value);

                if ((this.value == 2) || (this.value == 3)) {
                    pointerVue.showRow2 = true;
                }

                if ((this.value != 2) && (this.value != 3)) {
                    pointerVue.showRow2 = false;
                }

            });

            $('body').on('click', '#d_penalita_intervallo', function (event) {
                console.log(event);

                pointerVue.$modal.show('popupPenalitaIntervallo');

            });

            $('body').on('click', '.btn-confirm-penalitaintervallo', function (event) {
                console.log(event);

                pointerVue.risorsa.min_margine = pointerVue.valorePenalitaIntervallo;

                pointerVue.$root.$children[0].setFieldActive("#d_penalita_intervallo");

                pointerVue.$modal.hide('popupPenalitaIntervallo');

            });

            $('body').on('click', '.btn-cancel-penalitaintervallo', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupPenalitaIntervallo');

            });




            $('body').on('click', '#d_penalita_mm', function (event) {
                console.log(event);

                pointerVue.$modal.show('popupPenalitaMM');

            });

            $('body').on('click', '.btn-confirm-penalitamm', function (event) {
                console.log(event);

                pointerVue.risorsa.min_penalty = pointerVue.valorePenalitaMM;

                pointerVue.$root.$children[0].setFieldActive("#d_penalita_mm");

                pointerVue.$modal.hide('popupPenalitaMM');

            });

            $('body').on('click', '.btn-cancel-penalitamm', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupPenalitaMM');

            });

            $('body').on('click', '#cont_piano_orario', function (event) {
                console.log(event);



                pointerVue.loadPianoOrario($("#companyid").val());



            });


            $('body').on('click', '.cl-del-date-nascita', function (event) {
                console.log(event);


                pointerVue.risorsa.data_nascita = null;



            });

            $('body').on('click', '.cl-del-inizio-rapporto', function (event) {
                console.log(event);

                pointerVue.risorsa.inizio_rapporto = null;

            });

            $('body').on('click', '.cl-del-fine-rapporto', function (event) {
                console.log(event);

                pointerVue.risorsa.fine_rapporto = null;

            });







            $('body').on('click', '#d_val_ticket', function (event) {
                console.log(event);

                pointerVue.$modal.show('popupValTicket');

            });

            $('body').on('click', '.btn-confirm-valticket', function (event) {
                console.log(event);


                console.log("VAL INPUT: ", pointerVue.valoreTicket);

                if (pointerVue.valoreTicket != null) {


                    // aggiorno il costo giornaliero

                    // tolgo il vecchio valore 
                    pointerVue.risorsa.costo_giornaliero = parseFloat(pointerVue.formatValue(pointerVue.risorsa.costo_giornaliero)) - parseFloat(pointerVue.formatValue(pointerVue.risorsa.val_ticket));

                    pointerVue.risorsa.val_ticket = pointerVue.valoreTicket;

                    // aggiungo il nuovo valore
                    pointerVue.risorsa.costo_giornaliero = parseFloat(pointerVue.formatValue(pointerVue.risorsa.costo_giornaliero)) + parseFloat(pointerVue.formatValue(pointerVue.risorsa.val_ticket));



                    pointerVue.$root.$children[0].setFieldActive("#d_val_ticket");

                    pointerVue.$modal.hide('popupValTicket');

                }
                else {

                    pointerVue.$swal({
                        icon: "error",
                        text: "Valore richiesto",
                        showConfirmButton: false,
                        timer: 2000
                    });


                }

            });

            $('body').on('click', '.btn-cancel-valticket', function (event) {
                console.log(event);

                pointerVue.$modal.hide('popupValTicket');

            });

            $('body').on('blur', '#nome', function (event) {
                console.log(event);


                pointerVue.setupButtons();


            });

            $('body').on('blur', '#cognome', function (event) {
                console.log(event);


                pointerVue.setupButtons();


            });

            $('body').on('blur', '#cellulare', function (event) {
                console.log(event);


                pointerVue.setupButtons();


            });

            $('body').on('blur', '#mail', function (event) {
                console.log(event);


                pointerVue.setupButtons();


            });


            tinymce.init({
                selector: '#sec_description',  // change this value according to your HTML

                plugin: 'a_tinymce_plugin',
                height: "370",
                mode: "textareas",
                entity_encoding: "raw",
                add_unload_trigger: false,
                remove_linebreaks: false,
                apply_source_formatting: false,
                force_br_newlines: true,
                force_p_newlines: false,
                forced_root_block: '', // Needed for 3.x

                a_plugin_option: true,
                a_configuration_option: 400




            });


            tinymce.get('sec_description').on('blur', function (e) {
                // console.log(this); // "this" contains tinymce.Editor object
                console.log(e); // "this" contains tinymce.Editor object

                pointerVue.ads.description = tinymce.activeEditor.getContent();

                pointerVue.setupButtons();

            });

        });

    },

    components: {
        VueAutonumeric, ModalTableSelector,
    },

    computed: {

        filteredAziende() {

            return _.orderBy(this.aziende.filter(item => {
                if (!this.search) return this.aziende;
                return (item.companyname.toLowerCase().includes(this.search.toLowerCase()));
            }), 'headline')
        },

        filteredAziendeClienti() {

            return _.orderBy(this.aziendeclienti.filter(item => {
                if (!this.searchAziendeClienti) return this.aziendeclienti;
                return (item.fld_name.toLowerCase().includes(this.searchAziendeClienti.toLowerCase()));
            }), 'headline')
        },

        filteredDipartimenti() {

            return _.orderBy(this.dipartimenti.filter(item => {
                if (!this.searchDipartimento) return this.dipartimenti;
                return (item.fld_name.toLowerCase().includes(this.searchDipartimento.toLowerCase()));
            }), 'headline')
        },

        filteredTipologie() {

            return _.orderBy(this.tipologie.filter(item => {
                if (!this.searchTipologie) return this.tipologie;
                return (item.nome.toLowerCase().includes(this.searchTipologie.toLowerCase()));
            }), 'headline')
        },

        filteredUtentiAssociati() {

            return _.orderBy(this.utentiassociati.filter(item => {
                if (!this.searchUtentiAssociati) return this.utentiassociati;
                return (item.full_name_usr.toLowerCase().includes(this.searchUtentiAssociati.toLowerCase()));
            }), 'headline')
        },



        filteredClienti() {

            return _.orderBy(this.aziendeclienti.filter(item => {
                if (!this.searchClienti) return this.aziendeclienti;
                return (item.fld_name.toLowerCase().includes(this.searchClienti.toLowerCase()));
            }), 'headline')
        },


        filteredPianoOrario() {

            return _.orderBy(this.pianiorario.filter(item => {
                if (!this.searchPianoOrario) return this.pianiorario;
                return (item.descrizione.toLowerCase().includes(this.searchPianoOrario.toLowerCase()));
            }), 'headline')
        },





        solicitorsFeesDisplay: {
            get: function () {

                console.log("GET");

                if (this.pagamento.importo != undefined) {

                    return this.pagamento.importo.toFixed(2)

                } else {

                    return 0;

                }

            },
            set: function (newValue) {

                console.log("SET");

                if (newValue != "") {

                    console.log("SET VALUE; ", parseFloat(newValue).toFixed(2));

                    this.pagamento.importo = parseFloat(newValue).toFixed(2);

                }

            }
        }

    },

    data: () => ({

        nomeDetailedSkill: "",

        nomeComune: "",

        nomeProvincia: "",

        nomeRegione: "",

        nomeSottoCategoria: "",

        nomeGiornataLavoroTipo: "",

        nomeStudiMinimi: "",

        nomeTipoContratto: "",

        nomeAzienda: "",

        nomeCategoria: "",

        nomeScopo: "",

        titleSelectElement: "",

        selectedId: null,

        heightWindow: 0,
        widthWindow: 0,

        openDialog: false,
        itemList: [],


        viewForm: false,

        viewLocation: false,

        tipoAbilitazione: "D",

        valueGG: null,


        viewGiorniPartialRemote: false,


        tipoLavoro: [
            {
                "id": "Full Remote",
                "name": "Full Remote"
            },
            {
                "id": "Partial Remote",
                "name": "Partial Remote"
            },
            {
                "id": "In Presenza",
                "name": "On Site"
            }
        ],



        skillsTemp: [],

        idSkillsSel: [],


        panel: 0,


        portali: [],

        contrattiTemp: [],

        studiMinimiTemp: [],
        studiMinimi: [],

        tipoDiLavoroTemp: [],
        tipoDiLavoro: [],

        scopoTemp: [],
        scopo: [],

        categorieTemp: [],
        categorie: [],

        sottocategorieTemp: [],
        sottocategorie: [],

        regioniTemp: [],
        regioni: [],

        provinceTemp: [],
        province: [],

        comuniTemp: [],
        comuni: [],

        skillDetails: [],

        skills: [],

        urgent: [{ id: "S", value: "Si" }, { id: "N", value: "No" }],

        showOther: false,

        viewValTicket: false,

        valoreRAL: null,

        ads: {
            idcompany: "",
            title: "",
            description: "",
            date: "",
            expired_date: "",
            tipo_lavoro: "",
            idcategory: "",
            idsubcategory: "",
        },

        valCheckCable: "N",
        valCheckDesktop: "N",
        valCheckNotebook: "N",
        valCheckSoftwareLicence: "N",
        valCheckSmartphone: "N",
        valCheckSimAndNumber: "N",
        valCheckVeicoloAziendale: "N",
        valCheckAltro: "N",

        valoreFerieAP: null,
        valoreFerieAC: null,
        valorePermessiAP: null,
        valorePermessiAC: null,
        valoreProroga: null,
        valoreLordoMese: null,
        valoreDiaria: null,
        valoreTariffaNetta: null,
        valoreCostGiorn: null,
        valoreEbadgePausa: null,
        valorePenalitaIntervallo: null,
        valorePenalitaMM: null,

        valoreTicket: null,

        showPicker3: false,
        showPicker4: false,
        showPicker5: false,
        showPicker6: false,
        showPicker7: false,

        showRow1: false,
        showRow2: false,
        showRow3: false,
        showRow4: false,
        showRow5: false,
        showRow6: false,

        valoreDaPagare: null,
        valorePagato: null,
        valoreRimanente: null,

        valTotale: null,

        disField: false,
        disFieldRim: false,

        attachRemove: false,

        showImpRim: false,

        showImpPag: true,

        importoRimanente: 0,

        currentFile: null,

        ricerca_candidato: { nome: "", cognome: "", cellulare: "", mail: "", id_portale_lavoro: "", stato: "Da contattare" },
        dipendenti: [],
        tipidocumento: [],
        tipolaurea: [],
        contratti: [],
        interviste: [],
        tiporiscontro: [],
        tipocontratto: [],
        sedelavorativa: [],
        qualifica: [],
        ebadgetiporegistrazione: [],
        valoripianoorario: [],

        genere: [{
            id: "M",
            description: "Maschio"
        }, {
            id: "F",
            description: "Femmina"
        }],

        situazionefamigliare: [{
            id: "Celibe / Nubile",
            description: "Celibe / Nubile"
        }, {
            id: "Coniugato",
            description: "Coniugato"
        }, {
            id: "Separato",
            description: "Separato"
        }],

        itemPatenteGuida: [{
            id: "S",
            description: "Si"
        }, {
            id: "N",
            description: "No"
        }],

        itemAutomunito: [{
            id: "S",
            description: "Si"
        }, {
            id: "N",
            description: "No"
        }],

        ore: [],

        tipisgravi: [{
            id: "S",
            description: "Si"
        }, {
            id: "N",
            description: "No"
        }],

        veicoloaziendale: [{
            id: "S",
            description: "Si"
        }, {
            id: "N",
            description: "No"
        }],

        contrattoitaliano: [{
            id: "S",
            description: "Si"
        }, {
            id: "N",
            description: "No"
        }],

        ticket: [{
            id: "S",
            description: "Si"
        }, {
            id: "N",
            description: "No"
        }],

        abilitaebadge: [{
            id: "S",
            description: "Si"
        }, {
            id: "N",
            description: "No"
        }],

        vedistraordinari: [{
            id: "S",
            description: "Si"
        }, {
            id: "N",
            description: "No"
        }],

        ebadgeregtypeqr: [{
            id: "S",
            description: "Si"
        }, {
            id: "N",
            description: "No"
        }],

        ebadgeregtypeman: [{
            id: "S",
            description: "Si"
        }, {
            id: "N",
            description: "No"
        }],

        ebadgeregtyperec: [{
            id: "S",
            description: "Si"
        }, {
            id: "N",
            description: "No"
        }],

        ebadgearrotondamento: [{
            id: "S",
            description: "Si"
        }, {
            id: "N",
            description: "No"
        }],

        ebadgeverificaip: [{
            id: "S",
            description: "Si"
        }, {
            id: "N",
            description: "No"
        }],

        ebadgeinviamail: [{
            id: "S",
            description: "Si"
        }, {
            id: "N",
            description: "No"
        }],

        progetticaricaore: [{
            id: "S",
            description: "Si"
        }, {
            id: "N",
            description: "No"
        }],

        enablepanalita: [{
            id: "S",
            description: "Si"
        }, {
            id: "N",
            description: "No"
        }],



        currAzienda: "",
        titolo: "Aggiungi Annuncio",

        cur_id: 0,

        myValue: 0,

        sheetAziende: false,
        sheetDipendenti: false,
        searchDipendenti: "",
        search: "",

        sheetDipartimento: false,
        searchDipartimento: "",

        sheetTipologie: false,
        searchTipologie: "",

        sheetAziendeClienti: false,
        searchAziendeClienti: "",

        sheetUtentiAssociati: false,
        searchUtentiAssociati: "",

        sheetPianoOrario: false,
        searchPianoOrario: "",


        sheetClienti: false,
        searchClienti: "",

        tipologie2: [{
            "id": 1,
            "nome": "prova"
        }, {
            "id": 2,
            "nome": "prova2"
        }],

        showPicker: false,
        showPicker2: false,

        pagamento: {
            id_stato: ""
        },
        valid: true,
        initials: "",
        namesurname: "",
        iban: "",
        cellulare: "",
        codicefiscale: "",
        codicefiscaleRules: [
            (v) => !!v || "Codice fiscale is required",
            (v) => (v && v.length <= 16) || "Codice fiscale must be less than 16 characters",
        ],
        cellulareRules: [
            (v) => !!v || "Phone number is required",
            (v) => (v && v.length <= 30) || "Phone number must be less than 15 characters",
        ],
        genRules: [
            (v) => !!v || "Field required",

        ],
        ibanRules: [
            (v) => !!v || "Iban is required",
            (v) => (v && v.length <= 30) || "Iban must be less than 30 characters",
        ],
        email: "",
        emailRules: [
            (v) => !!v || "E-mail richiesta",
            (v) => /.+@.+\..+/.test(v) || "E-mail non valida",
        ],

        nameRules: [
            (v) => !!v || "Nome richiesto",
        ],

        phoneRules: [
            (v) => !!v || "Telefono richiesto",
        ],

        nucleoRules: [
            (v) => !!v || "Nucleo richiesto",
        ],

        fiscodeRules: [
            (v) => !!v || "Codice fiscale richiesto",
        ],

        idTipologiaRules: [
            (v) => !!v || "Tipologia richiesta",
        ],

        importoRules: [
            (v) => !!v || "Campo richiesto",
            (value) => (value && value.length >= 8 && value.length <= 10) || 'minimo 8 caratteri e massimo 10',
            (value) => (value && /[A-Z]/.test(value)) || 'Almeno un carattere maiuscolo',

        ],

        dataScadenzaRules: [
            (v) => !!v || "Data scadenza richiesta",
        ],

        select: null,
        checkbox: false,

        aziende: [],
        dipartimenti: [],
        dipartimentiTemp: [],

        aziendeclienti: [],
        aziendeclientiTemp: [],

        utentiassociati: [],
        utentiassociatiTemp: [],

        sediassunzioneTemp: [],
        sediassunzione: [],

        pianiorarioTemp: [],
        pianiorario: [],

    }),

    methods: {

        openPopupDetSkills: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");


            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apisottocategorie.getDetailsSkillsJobmule(
                that.ads.idcompany,
                v_token
            ).then((res) => {

                console.log("res from getDetailsSkillsJobmule", res);

                setTimeout(() => {

                    that.titleSelectElement = "Details Skills";

                    var DetSkills = [];


                    for (var x = 0; x < res.data.Result.length; x++) {

                        if (res.data.Result[x].name != null) {

                            DetSkills.push({
                                id: res.data.Result[x].name,
                                descrizione: res.data.Result[x].name
                            });

                        }



                    }

                    that.itemList = DetSkills;



                    that.heightWindow = 300;

                    that.widthWindow = 600;

                    console.log("ITEM LIST: ", that.itemList);


                    that.selectedId = "";

                    if (that.ads.detskill != "") {

                        that.selectedId = that.ads.detskill;

                    }

                    console.log("SEL ID CLIENTE: ", that.selectedId);

                    setTimeout(() => {

                        that.$root.$children[0].showProgress = false;

                        that.openDialog = true;

                    }, 200);


                }, 200);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );

        },

        openPopupDetSkillsOld: async function () {


            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            setTimeout(() => {

                that.titleSelectElement = "Details Skills";

                var DetSkills = [];


                for (var x = 0; x < that.skills.length; x++) {

                    if (that.skills[x].name != null) {

                        DetSkills.push({
                            id: that.skills[x].name,
                            descrizione: that.skills[x].name
                        });

                    }



                }

                that.itemList = DetSkills;



                that.heightWindow = 300;

                that.widthWindow = 600;

                console.log("ITEM LIST: ", that.itemList);


                that.selectedId = "";

                if (that.ads.detskill != "") {

                    that.selectedId = that.ads.detskill;

                }

                console.log("SEL ID CLIENTE: ", that.selectedId);

                setTimeout(() => {

                    that.$root.$children[0].showProgress = false;

                    that.openDialog = true;

                }, 200);


            }, 200);

        },


        openPopupComuni: async function () {


            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            setTimeout(() => {

                that.titleSelectElement = "Comune";

                var Comuni = [];


                for (var x = 0; x < that.comuni.length; x++) {

                    if (that.comuni[x].nome != null) {

                        Comuni.push({
                            id: that.comuni[x].idcomune,
                            descrizione: that.comuni[x].nome
                        });

                    }



                }

                that.itemList = Comuni;



                that.heightWindow = 300;

                that.widthWindow = 600;

                console.log("ITEM LIST: ", that.itemList);


                that.selectedId = "";

                if (that.ads.idcomune != "") {

                    that.selectedId = that.ads.idcomune;

                }

                console.log("SEL ID CLIENTE: ", that.selectedId);

                setTimeout(() => {

                    that.$root.$children[0].showProgress = false;

                    that.openDialog = true;

                }, 200);


            }, 200);

        },


        openPopupProvince: async function () {


            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            setTimeout(() => {

                that.titleSelectElement = "Provincia";

                var Province = [];


                for (var x = 0; x < that.province.length; x++) {

                    if (that.province[x].nome != null) {

                        Province.push({
                            id: that.province[x].idprovincia,
                            descrizione: that.province[x].nome
                        });

                    }



                }

                that.itemList = Province;



                that.heightWindow = 300;

                that.widthWindow = 600;

                console.log("ITEM LIST: ", that.itemList);


                that.selectedId = "";

                if (that.ads.idprovincia != "") {

                    that.selectedId = that.ads.idprovincia;

                }

                console.log("SEL ID CLIENTE: ", that.selectedId);

                setTimeout(() => {

                    that.$root.$children[0].showProgress = false;

                    that.openDialog = true;

                }, 200);


            }, 200);

        },


        openPopupRegioni: async function () {


            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            setTimeout(() => {

                that.titleSelectElement = "Regione";

                var Regioni = [];


                for (var x = 0; x < that.regioni.length; x++) {

                    if (that.regioni[x].nome != null) {

                        Regioni.push({
                            id: that.regioni[x].idregione,
                            descrizione: that.regioni[x].nome
                        });

                    }



                }

                that.itemList = Regioni;



                that.heightWindow = 300;

                that.widthWindow = 600;

                console.log("ITEM LIST: ", that.itemList);


                that.selectedId = "";

                if (that.ads.idregione != "") {

                    that.selectedId = that.ads.idregione;

                }

                console.log("SEL ID CLIENTE: ", that.selectedId);

                setTimeout(() => {

                    that.$root.$children[0].showProgress = false;

                    that.openDialog = true;

                }, 200);


            }, 200);

        },

        openPopupSottocategoria: async function () {

            var that = this;



            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apisottocategorie.getAdsSubCategoryJobmule(
                that.ads.idcompany,
                that.ads.idcategory
            ).then((res) => {

                console.log("res from getAdsSubCategoryJobmule", res);

                setTimeout(() => {

                    that.titleSelectElement = "Sotto Categoria";

                    var Scopi = [];


                    for (var x = 0; x < res.data.Result.length; x++) {

                        if (res.data.Result[x].description != null) {

                            Scopi.push({
                                id: res.data.Result[x].idsubcategory,
                                descrizione: res.data.Result[x].description
                            });

                        }



                    }

                    that.itemList = Scopi;



                    that.heightWindow = 300;

                    that.widthWindow = 600;

                    console.log("ITEM LIST: ", that.itemList);


                    that.selectedId = "";

                    if (that.ads.idsubcategory != "") {

                        that.selectedId = that.ads.idsubcategory;

                    }

                    console.log("SEL ID CLIENTE: ", that.selectedId);

                    setTimeout(() => {

                        that.$root.$children[0].showProgress = false;

                        that.openDialog = true;

                    }, 200);


                }, 200);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );

        },

        openPopupSottocategoriaOld: async function () {


            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            setTimeout(() => {

                that.titleSelectElement = "Sotto Categoria";

                var Sottocategorie = [];


                for (var x = 0; x < that.sottocategorie.length; x++) {

                    if (that.sottocategorie[x].description != null) {

                        Sottocategorie.push({
                            id: that.sottocategorie[x].idsubcategory,
                            descrizione: that.sottocategorie[x].description
                        });

                    }



                }

                that.itemList = Sottocategorie;



                that.heightWindow = 300;

                that.widthWindow = 600;

                console.log("ITEM LIST: ", that.itemList);


                that.selectedId = "";

                if (that.ads.idsubcategory != "") {

                    that.selectedId = that.ads.idsubcategory;

                }

                console.log("SEL ID CLIENTE: ", that.selectedId);

                setTimeout(() => {

                    that.$root.$children[0].showProgress = false;

                    that.openDialog = true;

                }, 200);


            }, 200);

        },

        openPopupGiornataLavoroTipo: async function () {

            var that = this;



            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apisottocategorie.getTypeWorkDayJobmule(
                that.ads.idcompany
            ).then((res) => {

                console.log("res from getTypeWorkDayJobmule", res);

                setTimeout(() => {

                    that.titleSelectElement = "Giornata Lavoro Tipo";

                    var GiornataLavoroTipo = [];


                    for (var x = 0; x < res.data.Result.length; x++) {

                        if (res.data.Result[x].description != null) {

                            GiornataLavoroTipo.push({
                                id: res.data.Result[x].idtypeworkday,
                                descrizione: res.data.Result[x].description
                            });

                        }



                    }

                    that.itemList = GiornataLavoroTipo;



                    that.heightWindow = 300;

                    that.widthWindow = 600;

                    console.log("ITEM LIST: ", that.itemList);


                    that.selectedId = "";

                    if (that.ads.idtypeworkday != "") {

                        that.selectedId = that.ads.idtypeworkday;

                    }

                    console.log("SEL ID CLIENTE: ", that.selectedId);

                    setTimeout(() => {

                        that.$root.$children[0].showProgress = false;

                        that.openDialog = true;

                    }, 200);


                }, 200);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );

        },

        openPopupGiornataLavoroTipoOld: async function () {


            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            setTimeout(() => {

                that.titleSelectElement = "Giornata Lavoro Tipo";

                var GiornataLavoroTipo = [];


                for (var x = 0; x < that.tipoDiLavoro.length; x++) {

                    if (that.tipoDiLavoro[x].description != null) {

                        GiornataLavoroTipo.push({
                            id: that.tipoDiLavoro[x].idtypeworkday,
                            descrizione: that.tipoDiLavoro[x].description
                        });

                    }



                }

                that.itemList = GiornataLavoroTipo;



                that.heightWindow = 300;

                that.widthWindow = 600;

                console.log("ITEM LIST: ", that.itemList);


                that.selectedId = "";

                if (that.ads.idtypeworkday != "") {

                    that.selectedId = that.ads.idtypeworkday;

                }

                console.log("SEL ID CLIENTE: ", that.selectedId);

                setTimeout(() => {

                    that.$root.$children[0].showProgress = false;

                    that.openDialog = true;

                }, 200);


            }, 200);

        },

        openPopupStudiMinimi: async function () {

            var that = this;



            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apisottocategorie.getMinStudyJobmule(
                that.ads.idcompany
            ).then((res) => {

                console.log("res from getMinStudyJobmule", res);

                setTimeout(() => {

                    that.titleSelectElement = "Studi Minimi";

                    var StudiMinimi = [];


                    for (var x = 0; x < res.data.Result.length; x++) {

                        if (res.data.Result[x].description != null) {

                            StudiMinimi.push({
                                id: res.data.Result[x].idstudy,
                                descrizione: res.data.Result[x].description
                            });

                        }



                    }

                    that.itemList = StudiMinimi;



                    that.heightWindow = 300;

                    that.widthWindow = 600;

                    console.log("ITEM LIST: ", that.itemList);


                    that.selectedId = "";

                    if (that.ads.idstudy != "") {

                        that.selectedId = that.ads.idstudy;

                    }

                    console.log("SEL ID CLIENTE: ", that.selectedId);

                    setTimeout(() => {

                        that.$root.$children[0].showProgress = false;

                        that.openDialog = true;

                    }, 200);


                }, 200);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );

        },


        openPopupStudiMinimiOld: async function () {


            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            setTimeout(() => {

                that.titleSelectElement = "Studi Minimi";

                var StudiMinimi = [];


                for (var x = 0; x < that.studiMinimi.length; x++) {

                    if (that.studiMinimi[x].description != null) {

                        StudiMinimi.push({
                            id: that.studiMinimi[x].idstudy,
                            descrizione: that.studiMinimi[x].description
                        });

                    }



                }

                that.itemList = StudiMinimi;



                that.heightWindow = 300;

                that.widthWindow = 600;

                console.log("ITEM LIST: ", that.itemList);


                that.selectedId = "";

                if (that.ads.idstudy != "") {

                    that.selectedId = that.ads.idstudy;

                }

                console.log("SEL ID CLIENTE: ", that.selectedId);

                setTimeout(() => {

                    that.$root.$children[0].showProgress = false;

                    that.openDialog = true;

                }, 200);


            }, 200);

        },

        openPopupTipoContratto: async function () {

            var that = this;


            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apisottocategorie.getContractTypeJobmule(
                that.ads.idcompany
            ).then((res) => {

                console.log("res from getContractTypeJobmule", res);

                setTimeout(() => {

                    that.titleSelectElement = "Tipo Contratto";

                    var TipiContratti = [];


                    for (var x = 0; x < res.data.Result.length; x++) {

                        if (res.data.Result[x].descrizione != null) {

                            TipiContratti.push({
                                id: res.data.Result[x].contratto,
                                descrizione: res.data.Result[x].descrizione
                            });

                        }



                    }

                    that.itemList = TipiContratti;



                    that.heightWindow = 300;

                    that.widthWindow = 600;

                    console.log("ITEM LIST: ", that.itemList);


                    that.selectedId = "";

                    if (that.ads.contratto != "") {

                        that.selectedId = that.ads.contratto;

                    }

                    console.log("SEL ID CLIENTE: ", that.selectedId);

                    setTimeout(() => {

                        that.$root.$children[0].showProgress = false;

                        that.openDialog = true;

                    }, 200);


                }, 200);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );

        },

        openPopupTipoContrattoOld: async function () {


            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            setTimeout(() => {

                that.titleSelectElement = "Tipo Contratto";

                var TipiContratti = [];


                for (var x = 0; x < that.contratti.length; x++) {

                    if (that.contratti[x].descrizione != null) {

                        TipiContratti.push({
                            id: that.contratti[x].contratto,
                            descrizione: that.contratti[x].descrizione
                        });

                    }



                }

                that.itemList = TipiContratti;



                that.heightWindow = 300;

                that.widthWindow = 600;

                console.log("ITEM LIST: ", that.itemList);


                that.selectedId = "";

                if (that.ads.contratto != "") {

                    that.selectedId = that.ads.contratto;

                }

                console.log("SEL ID CLIENTE: ", that.selectedId);

                setTimeout(() => {

                    that.$root.$children[0].showProgress = false;

                    that.openDialog = true;

                }, 200);


            }, 200);

        },

        openPopupAziende: async function () {

            var that = this;

            var v_token = window.$cookies.get("token");

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apisottocategorie.getCompanyJobmule(
                v_token
            ).then((res) => {

                console.log("res from getCompanyJobmule", res);

                setTimeout(() => {

                    that.titleSelectElement = "Azienda";

                    var Aziende = [];


                    for (var x = 0; x < res.data.Result.length; x++) {

                        if (res.data.Result[x].fld_name != null) {

                            Aziende.push({
                                id: res.data.Result[x].companyid,
                                descrizione: res.data.Result[x].fld_name
                            });

                        }



                    }

                    that.itemList = Aziende;



                    that.heightWindow = 300;

                    that.widthWindow = 600;

                    console.log("ITEM LIST: ", that.itemList);


                    that.selectedId = "";

                    if (that.ads.idcompany != "") {

                        that.selectedId = parseInt(that.ads.idcompany);

                    }

                    console.log("SEL ID CLIENTE: ", that.selectedId);

                    setTimeout(() => {

                        that.$root.$children[0].showProgress = false;

                        that.openDialog = true;

                    }, 200);


                }, 200);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );

        },

        openPopupAziendeOld: async function () {


            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            setTimeout(() => {

                that.titleSelectElement = "Azienda";

                var Aziende = [];


                for (var x = 0; x < that.aziende.length; x++) {

                    if (that.aziende[x].companyname != null) {

                        Aziende.push({
                            id: that.aziende[x].companyid,
                            descrizione: that.aziende[x].companyname
                        });

                    }



                }

                that.itemList = Aziende;



                that.heightWindow = 300;

                that.widthWindow = 600;

                console.log("ITEM LIST: ", that.itemList);


                that.selectedId = "";

                if (that.ads.idcompany != "") {

                    that.selectedId = parseInt(that.ads.idcompany);

                }

                console.log("SEL ID CLIENTE: ", that.selectedId);

                setTimeout(() => {

                    that.$root.$children[0].showProgress = false;

                    that.openDialog = true;

                }, 200);


            }, 200);

        },

        openPopupCategorie: async function () {

            var that = this;



            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apisottocategorie.getAdsCategoryJobmule(
                that.ads.idcompany
            ).then((res) => {

                console.log("res from getAdsCategoryJobmule", res);

                setTimeout(() => {

                    that.titleSelectElement = "Categoria";

                    var Scopi = [];


                    for (var x = 0; x < res.data.Result.length; x++) {

                        if (res.data.Result[x].description != null) {

                            Scopi.push({
                                id: res.data.Result[x].idcategory,
                                descrizione: res.data.Result[x].description
                            });

                        }



                    }

                    that.itemList = Scopi;



                    that.heightWindow = 300;

                    that.widthWindow = 600;

                    console.log("ITEM LIST: ", that.itemList);


                    that.selectedId = "";

                    if (that.ads.idcategory != "") {

                        that.selectedId = parseInt(that.ads.idcategory);

                    }

                    console.log("SEL ID CLIENTE: ", that.selectedId);

                    setTimeout(() => {

                        that.$root.$children[0].showProgress = false;

                        that.openDialog = true;

                    }, 200);


                }, 200);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );

        },

        openPopupCategorieOld: async function () {


            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            setTimeout(() => {

                that.titleSelectElement = "Categoria";

                var Categorie = [];


                for (var x = 0; x < that.categorie.length; x++) {

                    if (that.categorie[x].description != null) {

                        Categorie.push({
                            id: that.categorie[x].idcategory,
                            descrizione: that.categorie[x].description
                        });

                    }



                }

                that.itemList = Categorie;



                that.heightWindow = 300;

                that.widthWindow = 600;

                console.log("ITEM LIST: ", that.itemList);


                that.selectedId = "";

                if (that.ads.idcategory != "") {

                    that.selectedId = parseInt(that.ads.idcategory);

                }

                console.log("SEL ID CLIENTE: ", that.selectedId);

                setTimeout(() => {

                    that.$root.$children[0].showProgress = false;

                    that.openDialog = true;

                }, 200);


            }, 200);

        },

        openPopupScopi: async function () {

            var that = this;



            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apisottocategorie.getScopeJobmule(
                that.ads.idcompany
            ).then((res) => {

                console.log("res from getScopeJobmule", res);

                setTimeout(() => {

                    that.titleSelectElement = "Scopo";

                    var Scopi = [];


                    for (var x = 0; x < res.data.Result.length; x++) {

                        if (res.data.Result[x].description != null) {

                            Scopi.push({
                                id: res.data.Result[x].idscope,
                                descrizione: res.data.Result[x].description
                            });

                        }



                    }

                    that.itemList = Scopi;



                    that.heightWindow = 300;

                    that.widthWindow = 600;

                    console.log("ITEM LIST: ", that.itemList);


                    that.selectedId = "";

                    if (that.ads.idscope != "") {

                        that.selectedId = parseInt(that.ads.idscope);

                    }

                    console.log("SEL ID CLIENTE: ", that.selectedId);

                    setTimeout(() => {

                        that.$root.$children[0].showProgress = false;

                        that.openDialog = true;

                    }, 200);


                }, 200);


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile eliminare i dati");
                console.log("response", response);

            }

            );

        },

        openPopupScopiOld: async function () {


            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;


            setTimeout(() => {

                that.titleSelectElement = "Scopo";

                var Scopi = [];


                for (var x = 0; x < that.scopo.length; x++) {

                    if (that.scopo[x].description != null) {

                        Scopi.push({
                            id: that.scopo[x].idscope,
                            descrizione: that.scopo[x].description
                        });

                    }



                }

                that.itemList = Scopi;



                that.heightWindow = 300;

                that.widthWindow = 600;

                console.log("ITEM LIST: ", that.itemList);


                that.selectedId = "";

                if (that.ads.idscope != "") {

                    that.selectedId = parseInt(that.ads.idscope);

                }

                console.log("SEL ID CLIENTE: ", that.selectedId);

                setTimeout(() => {

                    that.$root.$children[0].showProgress = false;

                    that.openDialog = true;

                }, 200);


            }, 200);

        },

        refreshTable: async function () {

            var that = this;

            if (that.titleSelectElement == "Azienda") {

                that.showSpinner = true;
                that.$root.$children[0].showProgress = true;

                var response = await apisottocategorie.getCompanyJobmule(
                    v_token
                ).then((res) => {

                    console.log("res from getCompanyJobmule", res);

                    setTimeout(() => {



                        var Aziende = [];


                        for (var x = 0; x < res.data.Result.length; x++) {

                            if (res.data.Result[x].fld_name != null) {

                                Aziende.push({
                                    id: res.data.Result[x].companyid,
                                    descrizione: res.data.Result[x].fld_name
                                });

                            }



                        }

                        that.itemList = Aziende;



                        console.log("ITEM LIST: ", that.itemList);


                        that.selectedId = "";

                        if (that.ads.idcompany != "") {

                            that.selectedId = parseInt(that.ads.idcompany);

                        }

                        console.log("SEL ID CLIENTE: ", that.selectedId);

                        setTimeout(() => {

                            that.$root.$children[0].showProgress = false;


                        }, 200);


                    }, 200);


                }).catch(err => {
                    that.$root.$children[0].showProgress = false;
                    console.log(err);
                    var msg = err.response.data.Error;

                    that.$swal({
                        icon: "error",
                        text: msg,
                        showConfirmButton: false,
                        timer: 8000
                    });
                    console.log("Errori", "Non è stato possibile eliminare i dati");
                    console.log("response", response);

                }

                );


            }

            if (that.titleSelectElement == "Scopo") {

                that.showSpinner = true;
                that.$root.$children[0].showProgress = true;

                var response5 = await apisottocategorie.getScopeJobmule(
                    that.ads.idcompany
                ).then((res) => {

                    console.log("res from getScopeJobmule", res);

                    setTimeout(() => {



                        var Scopi = [];


                        for (var x = 0; x < res.data.Result.length; x++) {

                            if (res.data.Result[x].description != null) {

                                Scopi.push({
                                    id: res.data.Result[x].idscope,
                                    descrizione: res.data.Result[x].description
                                });

                            }



                        }

                        that.itemList = Scopi;


                        console.log("ITEM LIST: ", that.itemList);


                        that.selectedId = "";

                        if (that.ads.idscope != "") {

                            that.selectedId = parseInt(that.ads.idscope);

                        }

                        console.log("SEL ID CLIENTE: ", that.selectedId);

                        setTimeout(() => {

                            that.$root.$children[0].showProgress = false;


                        }, 200);


                    }, 200);


                }).catch(err => {
                    that.$root.$children[0].showProgress = false;
                    console.log(err);
                    var msg = err.response.data.Error;

                    that.$swal({
                        icon: "error",
                        text: msg,
                        showConfirmButton: false,
                        timer: 8000
                    });
                    console.log("Errori", "Non è stato possibile eliminare i dati");
                    console.log("response", response5);

                }

                );


            }

            if (that.titleSelectElement == "Categoria") {

                that.showSpinner = true;
                that.$root.$children[0].showProgress = true;


                setTimeout(() => {



                    var Categorie = [];


                    for (var x = 0; x < that.categorie.length; x++) {

                        if (that.categorie[x].description != null) {

                            Categorie.push({
                                id: that.categorie[x].idcategory,
                                descrizione: that.categorie[x].description
                            });

                        }



                    }

                    that.itemList = Categorie;



                    console.log("ITEM LIST: ", that.itemList);


                    that.selectedId = "";

                    if (that.ads.idcategory != "") {

                        that.selectedId = parseInt(that.ads.idcategory);

                    }

                    console.log("SEL ID CLIENTE: ", that.selectedId);

                    setTimeout(() => {

                        that.$root.$children[0].showProgress = false;


                    }, 200);


                }, 200);


            }

            if (that.titleSelectElement == "Tipo Contratto") {

                that.showSpinner = true;
                that.$root.$children[0].showProgress = true;

                var response2 = await apisottocategorie.getContractTypeJobmule(
                    that.ads.idcompany
                ).then((res) => {

                    console.log("res from getContractTypeJobmule", res);

                    setTimeout(() => {

                        that.titleSelectElement = "Tipo Contratto";

                        var TipiContratti = [];


                        for (var x = 0; x < res.data.Result.length; x++) {

                            if (res.data.Result[x].descrizione != null) {

                                TipiContratti.push({
                                    id: res.data.Result[x].contratto,
                                    descrizione: res.data.Result[x].descrizione
                                });

                            }



                        }

                        that.itemList = TipiContratti;


                        console.log("ITEM LIST: ", that.itemList);


                        that.selectedId = "";

                        if (that.ads.contratto != "") {

                            that.selectedId = that.ads.contratto;

                        }

                        console.log("SEL ID CLIENTE: ", that.selectedId);

                        setTimeout(() => {

                            that.$root.$children[0].showProgress = false;

                        }, 200);


                    }, 200);


                }).catch(err => {
                    that.$root.$children[0].showProgress = false;
                    console.log(err);
                    var msg = err.response.data.Error;

                    that.$swal({
                        icon: "error",
                        text: msg,
                        showConfirmButton: false,
                        timer: 8000
                    });
                    console.log("Errori", "Non è stato possibile eliminare i dati");
                    console.log("response", response2);

                }

                );


            }

            if (that.titleSelectElement == "Studi Minimi") {

                that.showSpinner = true;
                that.$root.$children[0].showProgress = true;

                var response3 = await apisottocategorie.getMinStudyJobmule(
                    that.ads.idcompany
                ).then((res) => {

                    console.log("res from getMinStudyJobmule", res);

                    setTimeout(() => {


                        var StudiMinimi = [];


                        for (var x = 0; x < res.data.Result.length; x++) {

                            if (res.data.Result[x].description != null) {

                                StudiMinimi.push({
                                    id: res.data.Result[x].idstudy,
                                    descrizione: res.data.Result[x].description
                                });

                            }



                        }

                        that.itemList = StudiMinimi;



                        console.log("ITEM LIST: ", that.itemList);


                        that.selectedId = "";

                        if (that.ads.idstudy != "") {

                            that.selectedId = that.ads.idstudy;

                        }

                        console.log("SEL ID CLIENTE: ", that.selectedId);

                        setTimeout(() => {

                            that.$root.$children[0].showProgress = false;

                        }, 200);


                    }, 200);


                }).catch(err => {
                    that.$root.$children[0].showProgress = false;
                    console.log(err);
                    var msg = err.response.data.Error;

                    that.$swal({
                        icon: "error",
                        text: msg,
                        showConfirmButton: false,
                        timer: 8000
                    });
                    console.log("Errori", "Non è stato possibile eliminare i dati");
                    console.log("response", response3);

                }

                );


            }

            if (that.titleSelectElement == "Giornata Lavoro Tipo") {

                that.showSpinner = true;
                that.$root.$children[0].showProgress = true;

                var response4 = await apisottocategorie.getTypeWorkDayJobmule(
                    that.ads.idcompany
                ).then((res) => {

                    console.log("res from getTypeWorkDayJobmule", res);

                    setTimeout(() => {


                        var GiornataLavoroTipo = [];


                        for (var x = 0; x < res.data.Result.length; x++) {

                            if (res.data.Result[x].description != null) {

                                GiornataLavoroTipo.push({
                                    id: res.data.Result[x].idtypeworkday,
                                    descrizione: res.data.Result[x].description
                                });

                            }



                        }

                        that.itemList = GiornataLavoroTipo;



                        console.log("ITEM LIST: ", that.itemList);


                        that.selectedId = "";

                        if (that.ads.idtypeworkday != "") {

                            that.selectedId = that.ads.idtypeworkday;

                        }

                        console.log("SEL ID CLIENTE: ", that.selectedId);

                        setTimeout(() => {

                            that.$root.$children[0].showProgress = false;



                        }, 200);


                    }, 200);


                }).catch(err => {
                    that.$root.$children[0].showProgress = false;
                    console.log(err);
                    var msg = err.response.data.Error;

                    that.$swal({
                        icon: "error",
                        text: msg,
                        showConfirmButton: false,
                        timer: 8000
                    });
                    console.log("Errori", "Non è stato possibile eliminare i dati");
                    console.log("response", response4);

                }

                );


            }

            if (that.titleSelectElement == "Sotto Categoria") {

                that.showSpinner = true;
                that.$root.$children[0].showProgress = true;


                setTimeout(() => {



                    var Sottocategorie = [];


                    for (var x = 0; x < that.sottocategorie.length; x++) {

                        if (that.sottocategorie[x].description != null) {

                            Sottocategorie.push({
                                id: that.sottocategorie[x].idsubcategory,
                                descrizione: that.sottocategorie[x].description
                            });

                        }



                    }

                    that.itemList = Sottocategorie;




                    console.log("ITEM LIST: ", that.itemList);


                    that.selectedId = "";

                    if (that.ads.idsubcategory != "") {

                        that.selectedId = that.ads.idsubcategory;

                    }

                    console.log("SEL ID CLIENTE: ", that.selectedId);

                    setTimeout(() => {

                        that.$root.$children[0].showProgress = false;


                    }, 200);


                }, 200);


            }

            if (that.titleSelectElement == "Regione") {

                that.showSpinner = true;
                that.$root.$children[0].showProgress = true;


                setTimeout(() => {



                    var Regioni = [];


                    for (var x = 0; x < that.regioni.length; x++) {

                        if (that.regioni[x].nome != null) {

                            Regioni.push({
                                id: that.regioni[x].idregione,
                                descrizione: that.regioni[x].nome
                            });

                        }



                    }

                    that.itemList = Regioni;





                    console.log("ITEM LIST: ", that.itemList);


                    that.selectedId = "";

                    if (that.ads.idregione != "") {

                        that.selectedId = that.ads.idregione;

                    }


                    console.log("SEL ID CLIENTE: ", that.selectedId);

                    setTimeout(() => {

                        that.$root.$children[0].showProgress = false;


                    }, 200);


                }, 200);


            }

            if (that.titleSelectElement == "Provincia") {

                that.showSpinner = true;
                that.$root.$children[0].showProgress = true;


                setTimeout(() => {



                    var Province = [];


                    for (var x = 0; x < that.province.length; x++) {

                        if (that.province[x].nome != null) {

                            Province.push({
                                id: that.province[x].idprovincia,
                                descrizione: that.province[x].nome
                            });

                        }



                    }

                    that.itemList = Province;





                    console.log("ITEM LIST: ", that.itemList);


                    that.selectedId = "";

                    if (that.ads.idprovincia != "") {

                        that.selectedId = that.ads.idprovincia;

                    }


                    console.log("SEL ID CLIENTE: ", that.selectedId);

                    setTimeout(() => {

                        that.$root.$children[0].showProgress = false;


                    }, 200);


                }, 200);


            }

            if (that.titleSelectElement == "Comune") {

                that.showSpinner = true;
                that.$root.$children[0].showProgress = true;


                setTimeout(() => {



                    var Comuni = [];


                    for (var x = 0; x < that.comuni.length; x++) {

                        if (that.comuni[x].nome != null) {

                            Comuni.push({
                                id: that.comuni[x].idcomune,
                                descrizione: that.comuni[x].nome
                            });

                        }



                    }

                    that.itemList = Comuni;






                    console.log("ITEM LIST: ", that.itemList);


                    that.selectedId = "";

                    if (that.ads.idcomune != "") {

                        that.selectedId = that.ads.idcomune;

                    }


                    console.log("SEL ID CLIENTE: ", that.selectedId);

                    setTimeout(() => {

                        that.$root.$children[0].showProgress = false;


                    }, 200);


                }, 200);


            }


            if (that.titleSelectElement == "Details Skills") {

                that.showSpinner = true;
                that.$root.$children[0].showProgress = true;


                setTimeout(() => {



                    var DetSkills = [];


                    for (var x = 0; x < that.skills.length; x++) {

                        if (that.skills[x].name != null) {

                            DetSkills.push({
                                id: that.skills[x].name,
                                descrizione: that.skills[x].name
                            });

                        }



                    }

                    that.itemList = DetSkills;






                    console.log("ITEM LIST: ", that.itemList);


                    that.selectedId = "";

                    if (that.ads.detskill != "") {

                        that.selectedId = that.ads.detskill;

                    }


                    console.log("SEL ID CLIENTE: ", that.selectedId);

                    setTimeout(() => {

                        that.$root.$children[0].showProgress = false;


                    }, 200);


                }, 200);


            }


        },

        loadData() {

            this.refreshTable();

        },


        handleConfirm(item) {

            console.log("ITEM: ", item);


            var that = this;

            var errore = "";

            if (item == null) {
                errore = "Selezionare un elemento";
            }

            if (errore == "") {

                console.log("ok");

                if (that.titleSelectElement == "Azienda") {

                    that.ads.idcompany = item.id;

                    that.selectedId = item.id;

                    that.nomeAzienda = item.descrizione;

                    that.ads.contratto = "";
                    that.nomeTipoContratto = "";
                    that.ads.idstudy = "";
                    that.nomeStudiMinimi = "";
                    that.ads.idtypeworkday = "";
                    that.nomeGiornataLavoroTipo = "";
                    that.ads.idscope = "";
                    that.nomeScopo = "";
                    that.ads.idcategory = "";
                    that.nomeCategoria = "";
                    that.ads.idsubcategory = "";
                    that.nomeSottoCategoria = "";
                    that.ads.detskill = "";
                    that.nomeDetailedSkill = "";
                    that.ads.idcomune = "";
                    that.nomeComune = "";
                    that.ads.idprovincia = "";
                    that.nomeProvincia = "";
                    that.ads.idregione = "";
                    that.nomeRegione = "";
                    that.idSkillsSel = "";

                    that.setContratti(item.id);

                    that.setStudiMinimi(item.id);

                    that.setTipoDiLavoro(item.id);

                    that.setScopo(item.id);

                    that.setCategorie(item.id);

                    that.setRegioni(item.id);

                    that.setSkills(item.id);

                    that.setupButtons();

                    that.$modal.hide('popupSelectElement');

                }

                if (that.titleSelectElement == "Scopo") {

                    that.ads.idscope = item.id;

                    that.selectedId = item.id;

                    that.nomeScopo = item.descrizione;

                    that.setupButtons();

                    that.$modal.hide('popupSelectElement');

                }

                if (that.titleSelectElement == "Categoria") {

                    that.ads.idcategory = item.id;

                    that.selectedId = item.id;

                    that.nomeCategoria = item.descrizione;

                    that.setSottoCategorie(item.id);

                    setTimeout(function () {

                        that.setupButtons();

                    }, 300);

                    that.$modal.hide('popupSelectElement');

                }

                if (that.titleSelectElement == "Tipo Contratto") {

                    that.ads.contratto = item.id;

                    that.selectedId = item.id;

                    that.nomeTipoContratto = item.descrizione;

                    that.setupButtons();

                    that.$modal.hide('popupSelectElement');

                }

                if (that.titleSelectElement == "Studi Minimi") {

                    that.ads.idstudy = item.id;

                    that.selectedId = item.id;

                    that.nomeStudiMinimi = item.descrizione;

                    that.setupButtons();

                    that.$modal.hide('popupSelectElement');

                }

                if (that.titleSelectElement == "Giornata Lavoro Tipo") {

                    that.ads.idtypeworkday = item.id;

                    that.selectedId = item.id;

                    that.nomeGiornataLavoroTipo = item.descrizione;

                    that.setupButtons();

                    that.$modal.hide('popupSelectElement');

                }

                if (that.titleSelectElement == "Sotto Categoria") {

                    that.ads.idsubcategory = item.id;

                    that.selectedId = item.id;

                    that.nomeSottoCategoria = item.descrizione;

                    that.setupButtons();

                    that.$modal.hide('popupSelectElement');

                }

                if (that.titleSelectElement == "Regione") {

                    that.ads.idregione = item.id;

                    that.selectedId = item.id;

                    that.nomeRegione = item.descrizione;

                    that.setProvince(item.id);

                    that.setupButtons();

                    that.$modal.hide('popupSelectElement');

                }

                if (that.titleSelectElement == "Provincia") {

                    that.ads.idprovincia = item.id;

                    that.selectedId = item.id;

                    that.nomeProvincia = item.descrizione;

                    that.setComuni(item.id);

                    that.setupButtons();

                    that.$modal.hide('popupSelectElement');

                }

                if (that.titleSelectElement == "Comune") {

                    that.ads.idcomune = item.id;

                    that.selectedId = item.id;

                    that.nomeComune = item.descrizione;

                    that.setupButtons();

                    that.$modal.hide('popupSelectElement');

                }

                if (that.titleSelectElement == "Details Skills") {

                    that.ads.detskill = item.id;

                    that.selectedId = item.id;

                    that.nomeDetailedSkill = item.descrizione;

                    that.loadDetailsSkills(item.id, that.ads.idcompany);


                    that.setupButtons();

                    that.$modal.hide('popupSelectElement');

                }

            }
            else {
                that.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: false,
                    timer: 3000
                });
            }

        },

        handleCancel() {
            console.log("Annullato");
        },

        handleDataInizioChange(newDate) {
            // Aggiorna lo stato showPicker
            this.showPicker = false;

            // Log della nuova data
            console.log("Nuova data selezionata:", newDate);

            const dateObj = new Date(newDate);

            // Aggiungi 30 giorni
            dateObj.setDate(dateObj.getDate() + 30);

            // Salva la data aggiornata
            var dateNew2 = dateObj.toISOString().substring(0, 10); // Formatta in "YYYY-MM-DD"

            console.log("Nuova data selezionata con 30 giorni:", dateNew2);

            this.ads.expired_date = dateNew2;

            // Esegui altre operazioni quando la data cambia
            // Ad esempio, un'API call o un aggiornamento di un altro componente
        },

        btnConfirmTypeEnable: function () {

            this.$modal.hide('popupTypeEnable');


            this.saveData();


        },



        loadDetailsSkills: function (id, companyid) {

            console.log("LOAD DET SKILLS ID: ", id);
            console.log("ID COMPANY: ", companyid);

            var SkillsDetails = [];

            for (var i = 0; i < this.skills.length; i++) {

                if (this.skills[i].name == id) {

                    for (var x = 0; x <= this.skills[i].details.length - 1; x++) {

                        if (parseInt(companyid) == parseInt(this.skills[i].details[x].company_id)) {

                            SkillsDetails.push({
                                id: this.skills[i].details[x].id,
                                name: this.skills[i].details[x].name
                            });


                        }


                    }




                }



            }

            console.log("SKILLS DET: ", SkillsDetails);

            this.skillDetails = SkillsDetails;


        },

        validateEMail: function () {

            var result;

            var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

            console.log("MAIL: ", $("#mail").val());

            if ($("#mail").val() != undefined) {

                if ($("#mail").val().match(validRegex)) {
                    result = true;
                }
                else {
                    result = false;

                }

            }
            else {
                result = true;

            }


            return result;

        },


        formatValue: function (v) {

            var res = v;

            if (res.toString().indexOf(',') != -1) {

                res = res.replace(".", "");
                res = res.replace(",", ".");


            }


            return res;
        },


        setupGridPianoOrario: function () {


            var pointerVue = this;



            $(document).ready(function () {

                var v_token = window.$cookies.get("token");

                window.columns = [{
                    data: 'codice',
                    orderable: false,
                    name: 'codice',
                    width: '2%'
                },

                {
                    data: 'descrizione',
                    orderable: false,
                    name: 'descrizione',
                    width: '2%'
                },







                ];



                window.table = $('#myTablePianoOrario').DataTable({
                    dom: "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>>" +
                        "<'rows colcontTable'<'col-sm-12 'tr>>" +
                        "<'row'<'col-sm-12 col-ok  col-md-12'i><'col-sm-12 col-ok-2  col-md-12'p>>",
                    "pagingType": "simple",
                    responsive: true,
                    "pageLength": window.perpage,

                    processing: false,
                    paging: false,
                    serverSide: false,

                    /*  pageSize: 30, */
                    "sDom": "lfrti",

                    data: window.dataset,

                    ajax: {
                        url: pointerVue.getUrlDomain("EmtPianoOrarioApi") + '?company_id=7&username=' + v_token,
                        data: function (valori) {

                            console.log("VALORI:", valori);

                            try {
                                window.table.clear().draw();

                            } catch (error) {
                                console.log(error);
                            }

                            window.start = window.perpage;

                            valori.start = 0;
                            valori.length = window.perpage;
                            valori.currDay = window.currDay;
                            valori.currDayTo = window.currDayTo;
                            valori.curStatus = window.curStatus;
                            valori.curPiano = window.curPiano;

                            var valSearch = $("#myTablePianoOrario_filter input").val();

                            var search = {
                                "value": $("#myTablePianoOrario_filter input").val(),
                                "regex": false
                            };

                            if (valSearch.length > 0) {
                                valori.search = search;
                                valori.columns = window.columns;
                                console.log(window.columns);
                            }

                            window.valori = valori;
                            return valori;

                        }

                    },

                    language: {

                        lengthMenu: `<label>Mostra<select name="myTable_length" aria-controls="myTable" class="custom-select custom-select-sm form-control-sm"><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option><option value="-1">Tutti</option></select>Inserimenti</label>`,

                        paginate: {
                            next: "<img style='height:15px;border:none' src='https://app.emtool.eu/_lib/img/next2.png'>",
                            previous: "<img style='height:15px;border:none' src='https://app.emtool.eu/_lib/img/previous2.png'>"
                        },

                        "sSearch": " ",
                        processing: '<svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>'
                    },
                    "info": "",
                    "fnDrawCallback": function (oSettings) {

                        console.log(oSettings);

                        $("body").tooltip({
                            selector: '[data-toggle="tooltip"]'
                        });
                    },

                    columns: window.columns,

                    "initComplete": function (settings) {

                        console.log(settings);

                        $("#myTablePianoOrario_wrapper").show();
                        $(".spin").hide();

                    },
                    "drawCallback": function (settings) {

                        console.log(settings);

                        $(".spin").hide();

                        var elements = $('.datetimeBook');
                        elements.each(function () {

                            var id = $(this).data("id");
                            (this).pickerOptions = {
                                buttons: [{
                                    text: 'Cancel',
                                    role: 'cancel',
                                    cssClass: 'switch-btn-cancel',
                                },
                                {
                                    text: 'Done',
                                    cssClass: 'switch-btn-done',
                                    handler: columns => {
                                        console.log("ore minuti id", columns.hour.text, columns.minute.text, id);
                                        var valore = columns.hour.text + ":" + columns.minute.text;

                                        console.log(valore);

                                        $.ajax({
                                            url: pointerVue.getUrlDomain("updateHour"),
                                            data: {
                                                "id": id,
                                                "hour": valore,
                                                "v_user": "ZmFnb3N0b25p"
                                            },
                                            success: function () { }
                                        });

                                    }
                                },
                                ],
                            };
                        });

                        setTimeout(function () {

                            //   $("#myTable_filter").width($("#myTable").width());

                        }, 300);

                        var selects = $('.selectstatus');
                        selects.each(function () {
                            var id = $(this).data("id");

                            console.log("ciaone", $(this).data("id"));

                            $(this).on("ionChange", function (opt) {

                                console.log(opt);

                                $(".spin").show();
                                $.ajax({
                                    url: pointerVue.getUrlDomain("updateStatus"),
                                    data: {
                                        "id": id,
                                        "hour": this.value,
                                        "v_user": "ZmFnb3N0b25p"
                                    },
                                    success: function () {
                                        window.table._fnDraw();
                                    }
                                });

                            });

                        });

                        $(".downloadspinner").hide();


                    }

                });




                //Events
                //START SETUP
                function throttle(f, delay) {
                    var timer = null;
                    return function () {
                        var context = this,
                            args = arguments;
                        clearTimeout(timer);
                        timer = window.setTimeout(function () {
                            f.apply(context, args);
                        },
                            delay || 500);
                    };
                }
                window.loading = 0;
                $("div.dataTables_filter input").unbind();
                $('div.dataTables_filter input').keyup(throttle(function () {
                    window.table.ajax.reload();

                }));
                $('#myTablePianoOrario_wrapper').on('scroll', function () {
                    if ($(this).scrollTop() + $(this).innerHeight() + 50 >= $(this)[0].scrollHeight) {
                        if (window.loading == 0) {
                            $(".spin").show();
                            var valori = window.valori;
                            valori.start = window.start;

                            $.ajax({
                                url: pointerVue.getUrlDomain("EmtPianoOrarioApi") + '?company_id=7&username=' + v_token,
                                data: window.valori,
                                success: function (data) {
                                    $(".spin").hide();
                                    window.loading = 0;
                                    window.start += window.perpage;

                                    for (let [index, val] of data.data.entries()) {
                                        console.log(index, val);
                                        window.table.row.add(val).draw(false);
                                        //  window.dataset.push(val);
                                    }
                                    console.log(data.data);
                                },
                            });
                        }
                        window.loading = 1;
                    }
                });
                //END

                var search = $(".dataTables_length").clone(true);
                search.attr("id", "final_search");
                $(".table_paginate").prepend(search);

                $("#myTablePianoOrario_wrapper .row .col-md-6").first().remove();

                $("#myTablePianoOrario_wrapper .row .col-md-6").first().removeClass("col-md-6");

                //alert (pathLocal);

                $("#myTable_filter").prepend(`
                <div class="cont_buttons">

                

                </div>
            `);



            });

        },







        onExpansionPanelClick(e) {

            console.log("EVENT: ", e);

            setTimeout(() => {

                var oggDrop = $('.dropify').dropify({
                    messages: {
                        default: 'Drag',
                        replace: /* s */ '',
                        remove: 'Rimuovi',
                        error: 'File troppo grande'
                    }
                });

                $(".dropify-clear").html("<img src='https://app.smart-book.it/_lib/img/icons8-cestino-64.png' />")
                $(".dropify-render").append("<img>");

                oggDrop.on('dropify.afterClear', function (event, element) {

                    console.log(event, element);

                    pointerVue.attachRemove = true;

                });


                console.log("RICERCA CANDIDATO: ", this.fattura);

                var allegato_salvato = this.ricerca_candidato.cv;

                if (allegato_salvato) {

                    var elements = allegato_salvato.split(".");

                    console.log("ELEMENTS: ", elements);


                    setTimeout(() => {



                        $('.dropify-render').append("<i class='dropify-font-file'></i>");
                        $('.dropify-render').append("<span class='dropify-extension'>" + elements[1] + "</span>");

                        // dropify-font-file
                        $(".dropify-wrapper").addClass("has-preview");
                        $(".dropify-preview").show("slow");

                    }, 100);

                }





            }, 100);


        },

        updateTotal() {

            console.log("LUNEDI: ", $(".lunedi").val());

            var v_lunedi = 0;
            if ($(".lunedi").val() != "") {
                v_lunedi = $(".lunedi").val();
            }

            var v_martedi = 0;
            if ($(".martedi").val() != "") {
                v_martedi = $(".martedi").val();
            }

            var v_mercoledi = 0;
            if ($(".mercoledi").val() != "") {
                v_mercoledi = $(".mercoledi").val();
            }

            var v_giovedi = 0;
            if ($(".giovedi").val() != "") {
                v_giovedi = $(".giovedi").val();
            }

            var v_venerdi = 0;
            if ($(".venerdi").val() != "") {
                v_venerdi = $(".venerdi").val();
            }

            var v_sabato = 0;
            if ($(".sabato").val() != "") {
                v_sabato = $(".sabato").val();
            }

            var v_domenica = 0;
            if ($(".domenica").val() != "") {
                v_domenica = $(".domenica").val();
            }

            var v_tot = parseFloat(v_lunedi) + parseFloat(v_martedi) + parseFloat(v_mercoledi) + parseFloat(v_giovedi) + parseFloat(v_venerdi) + parseFloat(v_sabato) + parseFloat(v_domenica);

            console.log("TOT: ", v_tot);

            this.valTotale = v_tot.toFixed(2);

        },

        formatDecimal(e) {

            //console.log("INPUT VALUE: ", e.target.value);

            // e.target.value = 3000;

            if (e.target.value != "") {

                var res = parseFloat(e.target.value);

                console.log("VAL: ", res.toFixed(2));

                e.target.value = res.toFixed(2);

                //e.target.value = e.target.value.toString().toFixed(2);

            }

        },

        checkImporto(e) {

            console.log("EVENT VALUE: ", e);

            if (e.target.value == "") {

                this.$root.$children[0].addClassError("#d_importo");

            } else {

                this.$root.$children[0].removeClassError("#d_importo");

            }

        },


        loadPianoOrario: async function (id_azienda) {


            var v_token = window.$cookies.get("token");

            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apirisorse.pianoOrarioAzienda(
                id_azienda,
                v_token
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from pianoOrarioAzienda", res);

                this.pianiorario = res.data.piano_orario;

                that.sheetPianoOrario = true;


            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }


            );



        },


        manageClickAziende: async function (azienda) {

            console.log("AZI SEL: ", azienda);

            this.sheetAziende = false;

            this.ads.idcompany = azienda.companyid;

            this.ads.contratto = "";
            this.ads.idstudy = "";
            this.ads.idtypeworkday = "";
            this.ads.idscope = "";
            this.ads.idcategory = "";
            this.ads.idsubcategory = "";
            this.ads.detskill = "";
            this.ads.idcomune = "";
            this.ads.idprovincia = "";
            this.ads.idregione = "";
            this.idSkillsSel = "";

            // this.ads.idregione = "";
            // this.ads.idprovincia = "";
            // this.ads.idcomune = "";


            this.setContratti(azienda.companyid);

            this.setStudiMinimi(azienda.companyid);

            this.setTipoDiLavoro(azienda.companyid);

            this.setScopo(azienda.companyid);

            this.setCategorie(azienda.companyid);

            this.setRegioni(azienda.companyid);

            this.setSkills(azienda.companyid);





            this.setupButtons();


        },

        manageClickPianoOrario: async function (pianoorario) {

            console.log("PO SEL: ", pianoorario);

            this.sheetPianoOrario = false;

            this.risorsa.codice_piano_orario = pianoorario.codice;



        },


        setPianiOrari: function (id_azienda) {

            console.log("AZI SEL 2: ", id_azienda);

            console.log("DIP TMP: ", this.pianiorarioTemp);

            var pianiOrari = [];

            for (var i = 0; i < this.pianiorarioTemp.length; i++) {

                if (parseInt(this.pianiorarioTemp[i].companyid) == parseInt(id_azienda)) {

                    pianiOrari.push({
                        codice: this.pianiorarioTemp[i].codice,
                        descrizione: this.pianiorarioTemp[i].descrizione,
                        lunedi: this.pianiorarioTemp[i].lunedi,
                        martedi: this.pianiorarioTemp[i].martedi,
                        mercoledi: this.pianiorarioTemp[i].mercoledi,
                        giovedi: this.pianiorarioTemp[i].giovedi,
                        venerdi: this.pianiorarioTemp[i].venerdi,
                        sabato: this.pianiorarioTemp[i].sabato,
                        domenica: this.pianiorarioTemp[i].domenica,
                        total: parseFloat(this.pianiorarioTemp[i].total).toFixed(2),



                    });

                }

            }

            console.log("PO SEL: ", pianiOrari);

            this.pianiorario = pianiOrari;

        },

        setContratti: function (id_azienda) {

            console.log("AZI SEL 2: ", id_azienda);

            console.log("DIP TMP: ", this.contrattiTemp);

            var Contratti = [];

            for (var i = 0; i < this.contrattiTemp.length; i++) {

                if (parseInt(this.contrattiTemp[i].companyid) == parseInt(id_azienda)) {

                    Contratti.push({
                        contratto: this.contrattiTemp[i].contratto,
                        descrizione: this.contrattiTemp[i].descrizione
                    });

                }

            }

            console.log("CONTR SEL: ", Contratti);

            this.contratti = Contratti;

        },


        setStudiMinimi: function (id_azienda) {

            console.log("AZI SEL 2: ", id_azienda);

            console.log("DIP TMP: ", this.studiMinimiTemp);

            var StudiMinimi = [];

            for (var i = 0; i < this.studiMinimiTemp.length; i++) {

                if (parseInt(this.studiMinimiTemp[i].companyid) == parseInt(id_azienda)) {

                    StudiMinimi.push({
                        idstudy: this.studiMinimiTemp[i].idstudy,
                        description: this.studiMinimiTemp[i].description
                    });

                }

            }

            console.log("CONTR SEL: ", StudiMinimi);

            this.studiMinimi = StudiMinimi;

        },


        setTipoDiLavoro: function (id_azienda) {

            console.log("AZI SEL 2: ", id_azienda);

            console.log("DIP TMP: ", this.tipoDiLavoroTemp);

            var TipoDiLavoro = [];

            for (var i = 0; i < this.tipoDiLavoroTemp.length; i++) {

                if (parseInt(this.tipoDiLavoroTemp[i].companyid) == parseInt(id_azienda)) {

                    TipoDiLavoro.push({
                        idtypeworkday: this.tipoDiLavoroTemp[i].idtypeworkday,
                        description: this.tipoDiLavoroTemp[i].description
                    });

                }

            }

            console.log("CONTR SEL: ", TipoDiLavoro);

            this.tipoDiLavoro = TipoDiLavoro;

        },


        setScopo: function (id_azienda) {

            console.log("AZI SEL 2: ", id_azienda);

            console.log("DIP TMP: ", this.scopoTemp);

            var Scopo = [];

            for (var i = 0; i < this.scopoTemp.length; i++) {

                if (parseInt(this.scopoTemp[i].companyid) == parseInt(id_azienda)) {

                    Scopo.push({
                        idscope: this.scopoTemp[i].idscope,
                        description: this.scopoTemp[i].description
                    });

                }

            }

            console.log("CONTR SEL: ", Scopo);

            this.scopo = Scopo;

        },

        setCategorie: function (id_azienda) {

            console.log("AZI SEL 2: ", id_azienda);

            console.log("DIP TMP: ", this.categorieTemp);

            var Categorie = [];

            for (var i = 0; i < this.categorieTemp.length; i++) {

                if (parseInt(this.categorieTemp[i].companyid) == parseInt(id_azienda)) {

                    Categorie.push({
                        idcategory: this.categorieTemp[i].idcategory,
                        description: this.categorieTemp[i].description
                    });

                }

            }

            console.log("CONTR SEL: ", Categorie);

            this.categorie = Categorie;

        },


        setSottoCategorie: function (id_categoria) {

            console.log("CAT SEL 2: ", id_categoria);

            console.log("DIP TMP: ", this.sottocategorieTemp);

            var SottoCategorie = [];

            for (var i = 0; i < this.sottocategorieTemp.length; i++) {

                if (parseInt(this.sottocategorieTemp[i].idcategory) == parseInt(id_categoria)) {

                    SottoCategorie.push({
                        idsubcategory: this.sottocategorieTemp[i].idsubcategory,
                        description: this.sottocategorieTemp[i].description
                    });

                }

            }

            console.log("CONTR SEL: ", SottoCategorie);

            this.sottocategorie = SottoCategorie;

        },


        setSkills: function (id_azienda) {

            console.log("AZI SEL 2: ", id_azienda);

            console.log("SKILLS TMP: ", this.skillsTemp);

            this.skills = [];
            this.skillDetails = [];

            this.ads.detskill = "";

            $(".detskill").val("");

            var Skills = [];

            for (var i = 0; i < this.skillsTemp.length; i++) {

                if (parseInt(this.skillsTemp[i].companyid) == parseInt(id_azienda)) {

                    Skills.push({
                        name: this.skillsTemp[i].name,
                        details: this.skillsTemp[i].details
                    });

                }

            }

            console.log("SKILLS SEL: ", Skills);

            this.skills = Skills;

        },




        setRegioni: function (id_azienda) {

            console.log("AZI SEL 2: ", id_azienda);

            console.log("DIP TMP: ", this.regioniTemp);

            var Regioni = [];

            for (var i = 0; i < this.regioniTemp.length; i++) {

                if (parseInt(this.regioniTemp[i].companyid) == parseInt(id_azienda)) {

                    Regioni.push({
                        idregione: this.regioniTemp[i].idregione,
                        nome: this.regioniTemp[i].nome
                    });

                }

            }

            console.log("CONTR SEL: ", Regioni);

            this.regioni = Regioni;

        },

        setProvince: function (id_regione) {

            console.log("REG SEL 2: ", id_regione);

            console.log("DIP TMP: ", this.provinceTemp);


            if (id_regione != "") {

                var Province = [];

                for (var i = 0; i < this.provinceTemp.length; i++) {

                    if (parseInt(this.provinceTemp[i].idregione) == parseInt(id_regione)) {

                        Province.push({
                            idprovincia: this.provinceTemp[i].idprovincia,
                            nome: this.provinceTemp[i].nome
                        });

                    }

                }

                console.log("CONTR SEL: ", Province);

                this.province = Province;

            }



        },




        setComuni: function (id_provincia) {

            console.log("PROV SEL 2: ", id_provincia);

            console.log("COMUNI TMP: ", this.comuniTemp);

            if (id_provincia != "") {

                var Comuni = [];

                for (var i = 0; i < this.comuniTemp.length; i++) {

                    if (parseInt(this.comuniTemp[i].idprovincia) == parseInt(id_provincia)) {

                        Comuni.push({
                            idcomune: this.comuniTemp[i].idcomune,
                            nome: this.comuniTemp[i].nome
                        });

                    }

                }

                console.log("COMUNI SEL: ", Comuni);

                this.comuni = Comuni;

            }



        },






        setAziendeClienti: function (id_azienda) {

            console.log("AZI SEL 2: ", id_azienda);

            console.log("DIP TMP: ", this.aziendeclientiTemp);

            var aziendeClienti = [];

            for (var i = 0; i < this.aziendeclientiTemp.length; i++) {

                if (parseInt(this.aziendeclientiTemp[i].our_company) == parseInt(id_azienda)) {

                    aziendeClienti.push({
                        companyid: this.aziendeclientiTemp[i].companyid,
                        fld_name: this.aziendeclientiTemp[i].fld_name
                    });

                }

            }

            console.log("AZI CLI SEL: ", aziendeClienti);

            this.aziendeclienti = aziendeClienti;

        },

        setUtenti: function (id_azienda) {

            console.log("AZI SEL 2: ", id_azienda);

            console.log("UTENTI TMP: ", this.utentiassociatiTemp);

            var utentiAssociati = [];

            for (var i = 0; i < this.utentiassociatiTemp.length; i++) {

                if (parseInt(this.utentiassociatiTemp[i].idcompany_logo) == parseInt(id_azienda)) {

                    utentiAssociati.push({
                        login: this.utentiassociatiTemp[i].login,
                        full_name_usr: this.utentiassociatiTemp[i].full_name_usr
                    });

                }

            }

            console.log("UT ASS SEL: ", utentiAssociati);

            this.utentiassociati = utentiAssociati;

        },




        setSediAssunzione: function (id_azienda) {

            console.log("AZI SEL 2: ", id_azienda);

            console.log("SEDI ASS TMP: ", this.sediassunzioneTemp);

            var sediAssunzione = [];

            for (var i = 0; i < this.sediassunzioneTemp.length; i++) {

                if (parseInt(this.sediassunzioneTemp[i].companyid) == parseInt(id_azienda)) {

                    sediAssunzione.push({
                        idsedeassunzione: this.sediassunzioneTemp[i].idsedeassunzione,
                        descrizione: this.sediassunzioneTemp[i].descrizione
                    });

                }

            }

            console.log("SEDI ASS SEL: ", sediAssunzione);

            this.sediassunzione = sediAssunzione;

        },





        manageClickDipartimenti: async function (dipartimento) {

            console.log("DIP SEL: ", dipartimento);

            this.sheetDipartimento = false;

            this.risorsa.departmentid = dipartimento.departmentid;

        },

        manageClickAziendeClienti: async function (aziendacliente) {

            console.log("AZI CLI SEL: ", aziendacliente);

            this.sheetAziendeClienti = false;

            this.risorsa.companycustomer = aziendacliente.companyid;

        },

        manageClickClienti: async function (aziendacliente) {

            console.log("AZI CLI SEL: ", aziendacliente);

            this.sheetClienti = false;

            this.risorsa.customer_id = aziendacliente.companyid;

        },



        manageClickUtentiAssociati: async function (utente) {

            console.log("UTENTE SEL: ", utente);

            this.sheetUtentiAssociati = false;

            this.risorsa.login = utente.login;

        },

        enableSaveButton: function () {

            var result = 1;

            console.log("ANNUNCIO: ", this.ads);

            if (this.ads.idcompany == "") {

                console.log("0");

                result = 0;
            }

            if (result == 1) {
                if (this.ads.title == "") {

                    console.log("1");

                    result = 0;
                }
            }

            if (result == 1) {
                if (this.ads.description == "") {

                    console.log("2");

                    result = 0;
                }
            }

            if (result == 1) {
                if (this.ads.date == "") {

                    console.log("3");

                    result = 0;
                }
            }

            if (result == 1) {
                if (this.ads.expired_date == "") {

                    console.log("4");

                    result = 0;
                }
            }

            if (result == 1) {
                if (this.ads.date == null) {

                    console.log("5");

                    result = 0;
                }
            }

            if (result == 1) {
                if (this.ads.expired_date == null) {

                    console.log("6");

                    result = 0;
                }
            }



            if (result == 1) {
                if (this.ads.tipo_lavoro != "") {

                    if (this.ads.tipo_lavoro == "Partial Remote") {


                        if ((this.valueGG == null) || (this.valueGG == "") || (this.valueGG == "0")) {

                            console.log("7");

                            result = 0;

                        }

                    }



                }
            }


            if (result == 1) {
                if (this.ads.idcategory == null) {

                    console.log("8");

                    result = 0;
                }
            }

            if (result == 1) {
                if (this.ads.idcategory == "") {

                    console.log("8");

                    result = 0;
                }
            }

            if (result == 1) {
                if (this.ads.idcategory == 0) {

                    console.log("8");

                    result = 0;
                }
            }


            if (result == 1) {
                if (this.ads.idsubcategory == null) {

                    console.log("9");

                    result = 0;
                }
            }

            if (result == 1) {
                if (this.ads.idsubcategory == "") {

                    console.log("9");

                    result = 0;
                }
            }

            if (result == 1) {
                if (this.ads.idsubcategory == 0) {

                    console.log("9");

                    result = 0;
                }
            }

            return result;

        },

        initSetupButtons: async function (v_enable) {

            setTimeout(() => {

                var pulsantis = [];


                if (v_enable) {

                    pulsantis.push({
                        text: "Salva",
                        icon: "mdi-content-save",
                        link: "/timesheet",
                        id: "btn_save_annuncio",
                        disabled: false,
                        image: "https://app.emtool.eu/public/_lib/img/save_update_data-careers.png",
                        title: "Salva",
                        width: 30,
                    });

                    pulsantis.push({
                        text: "Indietro",
                        icon: "mdi-arrow-left",
                        image: "https://app.emtool.eu/public/_lib/img/back-careers.png",
                        link: "/tipologiapagamento",
                        id: "btn_back_annuncio",
                        disabled: false,
                        title: "Indietro",
                        width: 35,
                    });

                }


                this.$root.$children[0].bnavbuttons = pulsantis;

            }, 100);

        },

        setupButtons: async function () {

            setTimeout(() => {

                var pulsantis = [];

                //var enableSave = this.enableSaveButton();


                var enableSave = 1;

                if (enableSave == 1) {

                    pulsantis.push({
                        text: "Salva",
                        icon: "mdi-content-save",
                        link: "/timesheet",
                        id: "btn_save_annuncio",
                        disabled: false,
                        image: "https://app.emtool.eu/public/_lib/img/save_update_data-careers.png",
                        title: "Salva",
                        width: 30,
                    });

                }

                pulsantis.push({
                    text: "Indietro",
                    icon: "mdi-arrow-left",
                    image: "https://app.emtool.eu/public/_lib/img/back-careers.png",
                    link: "/tipologiapagamento",
                    id: "btn_back_annuncio",
                    disabled: false,
                    title: "Indietro",
                    width: 35,
                });

                this.$root.$children[0].bnavbuttons = pulsantis;

            }, 100);

        },


        validate() {

            var that = this;


            var errore = "";

            console.log("ADS VAL: ", that.ads);

            if (that.ads.title == "") {
                errore = "Campo Titolo Richiesto";
            }

            if (errore == "") {
                if (that.ads.title == null) {
                    errore = "Campo Titolo Richiesto";
                }
            }

            if (errore == "") {
                if (that.ads.idcompany == "") {
                    errore = "Campo Azienda Richiesto";
                }
            }

            if (errore == "") {
                if (that.ads.idcompany == null) {
                    errore = "Campo Azienda Richiesto";
                }
            }


            if (errore == "") {
                if (that.ads.tipo_lavoro != "") {
                    if (that.ads.tipo_lavoro == "Partial Remote") {
                        if ((that.valueGG == null) || (that.valueGG == "") || (that.valueGG == "0")) {

                            errore = "Campo Giorni / Settimana Richiesto";
                        }
                    }
                }
            }

            if (errore == "") {
                if (that.ads.idcategory == "") {
                    errore = "Campo Categoria Richiesto";
                }
            }

            if (errore == "") {
                if (that.ads.idcategory == null) {
                    errore = "Campo Categoria Richiesto";
                }
            }

            if (errore == "") {
                if (that.ads.idsubcategory == "") {
                    errore = "Campo Sottocategoria Richiesto";
                }
            }

            if (errore == "") {
                if (that.ads.idsubcategory == null) {
                    errore = "Campo Sottocategoria Richiesto";
                }
            }


            if (errore == "") {
                if (that.ads.date == "") {
                    errore = "Campo Data Inizio Richiesto";
                }
            }

            if (errore == "") {
                if (that.ads.date == null) {
                    errore = "Campo Data Inizio Richiesto";
                }
            }

            if (errore == "") {
                if (that.ads.expired_date == "") {
                    errore = "Campo Data Scadenza Richiesto";
                }
            }

            if (errore == "") {
                if (that.ads.expired_date == null) {
                    errore = "Campo Data Scadenza Richiesto";
                }
            }

            if (errore == "") {
                if (that.ads.description == "") {
                    errore = "Campo Descrizione Richiesto";
                }
            }

            if (errore == "") {
                if (that.ads.description == null) {
                    errore = "Campo Descrizione Richiesto";
                }
            }

            if (errore == "") {


                if (this.$route.params.id == 0) {


                    that.tipoAbilitazione = "D";


                    $(".contpopuptypeenable").show();

                    that.$modal.show('popupTypeEnable');

                }

                if (this.$route.params.id > 0) {

                    that.saveData();


                }







            }
            else {

                that.$swal({
                    icon: "error",
                    text: errore,
                    showConfirmButton: false,
                    timer: 2000
                });


            }



        },


        getUrlDomain: function (nome_metodo) {

            let result = "";

            if ($(location).attr('hostname') == "localhost") {
                result = $(location).attr('protocol') + "//emtool.local/";
            }

            if ($(location).attr('hostname') != "localhost") {

                result = "https://companysupport.eu/";

            }

            return result + "" + nome_metodo;

        },


        initInsertAds: async function () {

            var v_token = window.$cookies.get("token");
            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apiads.initInsertAds(
                v_token,
                "Jobmule"
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from initInsertAds", res);

                this.aziende = res.data.company;
                this.contrattiTemp = res.data.contracttype;
                this.studiMinimiTemp = res.data.minstudy;
                this.tipoDiLavoroTemp = res.data.typeworkday;
                this.scopoTemp = res.data.idscope;
                this.categorieTemp = res.data.idcategoria;
                this.sottocategorieTemp = res.data.idsubcategoria;
                this.regioniTemp = res.data.region;
                this.provinceTemp = res.data.province;
                this.comuniTemp = res.data.comuni;
                this.skillsTemp = res.data.skills;




            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );

        },



        initEditAds: async function () {

            var v_token = window.$cookies.get("token");
            var that = this;

            window.doEventChangeIdProvincia = 0;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apiads.initEditAds(
                that.$route.params.id,
                v_token,
                "Jobmule"
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from initEditAds", res);

                console.log("N_GG: ", res.data.ads.n_gg);

                this.aziende = res.data.company;
                this.contrattiTemp = res.data.contracttype;
                this.studiMinimiTemp = res.data.minstudy;
                this.tipoDiLavoroTemp = res.data.typeworkday;
                this.scopoTemp = res.data.idscope;
                this.categorieTemp = res.data.idcategoria;
                this.sottocategorieTemp = res.data.idsubcategoria;
                this.regioniTemp = res.data.region;
                this.provinceTemp = res.data.province;
                this.comuniTemp = res.data.comuni;

                this.skillsTemp = res.data.skills;

                //this.skills = res.data.skills;

                this.setContratti(res.data.ads.idcompany);

                this.setStudiMinimi(res.data.ads.idcompany);

                this.setTipoDiLavoro(res.data.ads.idcompany);

                this.setScopo(res.data.ads.idcompany);

                this.setCategorie(res.data.ads.idcompany);

                this.setRegioni(res.data.ads.idcompany);

                this.setSkills(res.data.ads.idcompany);

                if (res.data.ads.idcategory != null) {

                    this.setSottoCategorie(res.data.ads.idcategory);

                }

                if (res.data.ads.idregione != null) {

                    this.setProvince(res.data.ads.idregione);

                }

                if (res.data.ads.idprovincia != null) {

                    this.setComuni(res.data.ads.idprovincia);

                }

                this.ads = res.data.ads;


                if (res.data.ads.detailedskills != null) {

                    var elements = res.data.ads.detailedskills.split(",");

                    console.log("ELE SKILLS: ", elements);

                    this.idSkillsSel = elements;


                }


                if (this.ads.idcompany != null) {
                    $("#itemCompany").addClass("item-has-value");
                }

                if (this.ads.contratto != null) {
                    $("#itemContratto").addClass("item-has-value");
                }

                if (this.ads.idstudy != null) {
                    $("#itemIdStudy").addClass("item-has-value");
                }

                if (this.ads.idtypeworkday != null) {
                    $("#itemIdTypeWorkDay").addClass("item-has-value");
                }

                if (this.ads.idscope != null) {
                    $("#itemIdScope").addClass("item-has-value");
                }

                if (this.ads.idcategory != null) {
                    $("#itemIdCategory").addClass("item-has-value");
                }

                if (this.ads.idsubcategory != null) {
                    $("#itemIdSubCategory").addClass("item-has-value");
                }

                if (this.ads.idregione != null) {
                    $("#itemIdRegione").addClass("item-has-value");
                }

                if (this.ads.idprovincia != null) {
                    $("#itemIdProvincia").addClass("item-has-value");
                }

                if (this.ads.idcomune != null) {
                    $("#itemIdComune").addClass("item-has-value");
                }

                if (this.ads.isurgent != null) {
                    $("#itemIsUrgent").addClass("item-has-value");
                }



                this.valueGG = res.data.num_gg;

                this.viewGiorniPartialRemote = false;

                this.viewLocation = false;

                if (this.ads.tipo_lavoro != null) {

                    if (this.ads.tipo_lavoro == "Partial Remote") {

                        this.viewGiorniPartialRemote = true;

                        this.viewLocation = true;

                        window.doEventChangeIdProvincia = 1;


                    }

                    if (this.ads.tipo_lavoro == "In Presenza") {

                        this.viewLocation = true;

                        window.doEventChangeIdProvincia = 1;

                    }

                }

                setTimeout(() => {

                    that.nomeAzienda = "";
                    // if (that.aziende.length > 0) {
                    //     if (that.ads.idcompany != null) {
                    //         for (var xx = 0; xx < that.aziende.length; xx++) {
                    //             if (parseInt(that.ads.idcompany) == parseInt(that.aziende[xx].companyid)) {
                    //                 that.nomeAzienda = that.aziende[xx].companyname;
                    //             }
                    //         }
                    //     }
                    // }

                    if (that.ads.idcompany != null) {
                        if (that.ads.idcompany == 7) {
                            that.nomeAzienda = "LC-Service srl";
                        }
                        else {
                            if (that.ads.idcompany == 8) {
                                that.nomeAzienda = "ARIALL srl";
                            }
                            else {

                                for (var xx = 0; xx < that.aziende.length; xx++) {
                                    if (parseInt(that.ads.idcompany) == parseInt(that.aziende[xx].companyid)) {
                                        that.nomeAzienda = that.aziende[xx].companyname;
                                    }
                                }
                            }
                        }
                    }


                    that.nomeTipoContratto = "";
                    if (that.contratti.length > 0) {
                        if (that.ads.contratto != null) {
                            for (var xx2 = 0; xx2 < that.contratti.length; xx2++) {
                                if (that.ads.contratto == that.contratti[xx2].contratto) {
                                    that.nomeTipoContratto = that.contratti[xx2].descrizione;
                                }
                            }
                        }
                    }

                    that.nomeStudiMinimi = "";
                    if (that.studiMinimi.length > 0) {
                        if (that.ads.idstudy != null) {
                            for (var xx3 = 0; xx3 < that.studiMinimi.length; xx3++) {
                                if (that.ads.idstudy == that.studiMinimi[xx3].idstudy) {
                                    that.nomeStudiMinimi = that.studiMinimi[xx3].description;
                                }
                            }
                        }
                    }

                    that.nomeGiornataLavoroTipo = "";
                    if (that.tipoDiLavoro.length > 0) {
                        if (that.ads.idtypeworkday != null) {
                            for (var xx4 = 0; xx4 < that.tipoDiLavoro.length; xx4++) {
                                if (that.ads.idtypeworkday == that.tipoDiLavoro[xx4].idtypeworkday) {
                                    that.nomeGiornataLavoroTipo = that.tipoDiLavoro[xx4].description;
                                }
                            }
                        }
                    }

                    that.nomeScopo = "";
                    if (that.scopo.length > 0) {
                        if (that.ads.idscope != null) {
                            for (var xx5 = 0; xx5 < that.scopo.length; xx5++) {
                                if (that.ads.idscope == that.scopo[xx5].idscope) {
                                    that.nomeScopo = that.scopo[xx5].description;
                                }
                            }
                        }
                    }

                    that.nomeCategoria = "";
                    if (that.categorie.length > 0) {
                        if (that.ads.idcategory != null) {
                            for (var xx6 = 0; xx6 < that.categorie.length; xx6++) {
                                if (that.ads.idcategory == that.categorie[xx6].idcategory) {
                                    that.nomeCategoria = that.categorie[xx6].description;
                                }
                            }
                        }
                    }

                    that.nomeSottoCategoria = "";
                    if (that.sottocategorie.length > 0) {
                        if (that.ads.idsubcategory != null) {
                            for (var xx7 = 0; xx7 < that.sottocategorie.length; xx7++) {
                                if (that.ads.idsubcategory == that.sottocategorie[xx7].idsubcategory) {
                                    that.nomeSottoCategoria = that.sottocategorie[xx7].description;
                                }
                            }
                        }
                    }

                    that.nomeRegione = "";
                    if (that.regioni.length > 0) {
                        if (that.ads.idregione != null) {
                            for (var xx8 = 0; xx8 < that.regioni.length; xx8++) {
                                if (that.ads.idregione == that.regioni[xx8].idregione) {
                                    that.nomeRegione = that.regioni[xx8].nome;
                                }
                            }
                        }
                    }

                    that.nomeProvincia = "";
                    if (that.province.length > 0) {
                        if (that.ads.idprovincia != null) {
                            for (var xx9 = 0; xx9 < that.province.length; xx9++) {
                                if (that.ads.idprovincia == that.province[xx9].idprovincia) {
                                    that.nomeProvincia = that.province[xx9].nome;
                                }
                            }
                        }
                    }

                    that.nomeComune = "";
                    if (that.comuni.length > 0) {
                        if (that.ads.idcomune != null) {
                            for (var xx10 = 0; xx10 < that.comuni.length; xx10++) {
                                if (that.ads.idcomune == that.comuni[xx10].idcomune) {
                                    that.nomeComune = that.comuni[xx10].nome;
                                }
                            }
                        }
                    }

                    that.nomeDetailedSkill = "";
                    if (that.ads.detailedskills != null) {
                        if (that.ads.detailedskills != "") {
                            var elements = that.ads.detailedskills.split(",");
                            console.log("ELEMENTS: ", elements);

                            var id_element = elements[0];




                            for (var i11 = 0; i11 < that.skills.length; i11++) {



                                for (var x11 = 0; x11 <= that.skills[i11].details.length - 1; x11++) {

                                    console.log("ID ELEMENT: ", parseInt(id_element));
                                    console.log("ID ELEMENT 2: ", parseInt(that.skills[i11].details[x11].id));

                                    if (parseInt(id_element) == parseInt(that.skills[i11].details[x11].id)) {

                                        console.log("FIND");
                                        console.log("NAME: ", that.skills[i11].name);

                                        that.nomeDetailedSkill = that.skills[i11].name;


                                    }


                                }


                            }

                            that.idSkillsSel = [];
                            for (var jj = 0; jj < elements.length; jj++) {
                                that.idSkillsSel.push(parseInt(elements[jj]));
                            }

                            //that.idSkillsSel.push(27);

                            console.log("SKILL SEL: ", that.idSkillsSel);


                            that.loadDetailsSkills(that.nomeDetailedSkill, that.ads.idcompany);

                        }
                    }

                }, 200);


                setTimeout(() => {
                    tinymce.activeEditor.setContent(res.data.ads.description);

                    // $("#fldNGG").val("20");

                    // $("#fldNGG").val(res.data.num_gg);

                    setTimeout(() => {






                        this.setupButtons();

                    }, 1000);

                }, 700);



            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );

        },




        syncPianoOrario: async function () {

            var v_token = window.$cookies.get("token");

            var that = this;

            var id_rec = that.$route.params.id;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apipianoorario.getPianoOrario(
                id_rec,
                v_token
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from getPianoOrario", res);

                this.aziende = res.data.company;

                this.ore = res.data.ore;

                this.pianoorario = res.data.piano_orario;

                $("#itemCompany").addClass("item-has-value");

                if (this.pianoorario.lunedi != null) {

                    $("#itemLunedi").addClass("item-has-value");

                }

                if (this.pianoorario.martedi != null) {

                    $("#itemMartedi").addClass("item-has-value");

                }

                if (this.pianoorario.mercoledi != null) {

                    $("#itemMercoledi").addClass("item-has-value");

                }

                if (this.pianoorario.giovedi != null) {

                    $("#itemGiovedi").addClass("item-has-value");

                }

                if (this.pianoorario.venerdi != null) {

                    $("#itemVenerdi").addClass("item-has-value");

                }

                if (this.pianoorario.sabato != null) {

                    $("#itemSabato").addClass("item-has-value");

                }

                if (this.pianoorario.domenica != null) {

                    $("#itemDomenica").addClass("item-has-value");

                }

            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("Errori", "Non è stato possibile salvare i dati");
                console.log("response", response);

            }

            );

        },


        saveData: async function () {


            var that = this;


            // if ($(".contratto").val() != "") {
            //     that.ads.contratto = $(".contratto").val();
            // }

            // if ($(".idstudy").val() != "") {
            //     that.ads.idstudy = $(".idstudy").val();
            // }

            // if ($(".idtypeworkday").val() != "") {
            //     that.ads.idtypeworkday = $(".idtypeworkday").val();
            // }

            // if ($(".idscope").val() != "") {
            //     that.ads.idscope = $(".idscope").val();
            // }

            // if ($(".idcategory").val() != "") {
            //     that.ads.idcategory = $(".idcategory").val();
            // }

            // if ($(".idsubcategory").val() != "") {
            //     that.ads.idsubcategory = $(".idsubcategory").val();
            // }

            // if ($(".idregione").val() != "") {
            //     that.ads.idregione = $(".idregione").val();
            // }

            // if ($(".idprovincia").val() != "") {
            //     that.ads.idprovincia = $(".idprovincia").val();
            // }

            if ($(".isurgent").val() != "") {
                that.ads.isurgent = $(".isurgent").val();
            }

            // if ($(".idcomune").val() != "") {
            //     that.ads.idcomune = $(".idcomune").val();
            // }


            if (that.ads.durata == null) {
                that.ads.durata = "";
            }

            if (that.ads.year_experience == null) {
                that.ads.year_experience = "";
            }

            if (that.ads.level_work == null) {
                that.ads.level_work = "";
            }

            if (that.ads.kwoledge == null) {
                that.ads.kwoledge = "";
            }


            console.log("ADS: ", that.ads);
            console.log("SKILLS: ", that.idSkillsSel);

            var v_id_skills = "";
            for (var x = 0; x <= that.idSkillsSel.length - 1; x++) {
                if (v_id_skills != "") {
                    v_id_skills = v_id_skills + ",";
                }
                v_id_skills = v_id_skills + that.idSkillsSel[x];
            }


            var v_token = window.$cookies.get("token");

            var id_rec = that.$route.params.id;



            that.ads.n_gg = that.valueGG;



            that.ads.detskill = "";



            if (id_rec == 0) {

                that.showSpinner = true;
                that.$root.$children[0].showProgress = true;

                var response = await apiads.insertAds(
                    that.ads,
                    v_token,
                    v_id_skills,
                    that.tipoAbilitazione
                ).then(async (res) => {

                    that.$root.$children[0].showProgress = false;
                    console.log("res from insertAds", res);

                    that.$swal({
                        icon: "success",
                        text: "Dati salvati correttamente",
                        showConfirmButton: false,
                        timer: 2000
                    });

                    setTimeout(() => {

                        that.dialogMsg = false;
                        that.setupButtons();

                        router.push({
                            path: "/annunci"
                        });

                    }, 200);



                }).catch(err => {
                    that.$root.$children[0].showProgress = false;
                    console.log(err);
                    var msg = err.response.data.Error;

                    that.$swal({
                        icon: "error",
                        text: msg,
                        showConfirmButton: false,
                        timer: 8000
                    });
                    console.log("Errori", "Non è stato possibile salvare i dati");
                    console.log("response", response);

                }


                );

            }

            if (id_rec > 0) {




                that.showSpinner = true;
                that.$root.$children[0].showProgress = true;

                var response8 = await apiads.updateAds(
                    that.ads,
                    v_token,
                    v_id_skills,
                    id_rec
                ).then(async (res) => {

                    that.$root.$children[0].showProgress = false;
                    console.log("res from updateAds", res);

                    that.$swal({
                        icon: "success",
                        text: "Dati salvati correttamente",
                        showConfirmButton: false,
                        timer: 2000
                    });

                    setTimeout(() => {

                        that.dialogMsg = false;
                        that.setupButtons();

                        router.push({
                            path: "/annunci"
                        });

                    }, 200);

                }).catch(err => {
                    that.$root.$children[0].showProgress = false;
                    console.log(err);
                    var msg = err.response.data.Error;

                    that.$swal({
                        icon: "error",
                        text: msg,
                        showConfirmButton: false,
                        timer: 8000
                    });
                    console.log("Errori", "Non è stato possibile salvare i dati");
                    console.log("response", response8);

                }


                );




            }

        },







        saveDataOld: async function () {


            var that = this;


            if ($(".contratto").val() != "") {
                that.ads.contratto = $(".contratto").val();
            }

            if ($(".idstudy").val() != "") {
                that.ads.idstudy = $(".idstudy").val();
            }

            if ($(".idtypeworkday").val() != "") {
                that.ads.idtypeworkday = $(".idtypeworkday").val();
            }

            if ($(".idscope").val() != "") {
                that.ads.idscope = $(".idscope").val();
            }

            if ($(".idcategory").val() != "") {
                that.ads.idcategory = $(".idcategory").val();
            }

            if ($(".idsubcategory").val() != "") {
                that.ads.idsubcategory = $(".idsubcategory").val();
            }

            if ($(".idregione").val() != "") {
                that.ads.idregione = $(".idregione").val();
            }

            if ($(".idprovincia").val() != "") {
                that.ads.idprovincia = $(".idprovincia").val();
            }

            if ($(".isurgent").val() != "") {
                that.ads.isurgent = $(".isurgent").val();
            }

            if ($(".idcomune").val() != "") {
                that.ads.idcomune = $(".idcomune").val();
            }


            if (that.ads.durata == null) {
                that.ads.durata = "";
            }

            if (that.ads.year_experience == null) {
                that.ads.year_experience = "";
            }

            if (that.ads.level_work == null) {
                that.ads.level_work = "";
            }

            if (that.ads.kwoledge == null) {
                that.ads.kwoledge = "";
            }


            console.log("ADS: ", that.ads);
            console.log("SKILLS: ", that.idSkillsSel);

            var v_id_skills = "";
            for (var x = 0; x <= that.idSkillsSel.length - 1; x++) {
                if (v_id_skills != "") {
                    v_id_skills = v_id_skills + ",";
                }
                v_id_skills = v_id_skills + that.idSkillsSel[x];
            }


            var v_token = window.$cookies.get("token");

            var id_rec = that.$route.params.id;




            if (id_rec == 0) {

                that.showSpinner = true;
                that.$root.$children[0].showProgress = true;

                var response = await apiads.insertAds(
                    that.ads,
                    v_token,
                    v_id_skills
                ).then(async (res) => {

                    console.log("res from insertAds", res);
                    console.log("isurgent: ", that.ads.isurgent);
                    console.log("idcompany: ", that.ads.idcompany);

                    var id_ads = res.data.IdAds;

                    if (that.ads.isurgent == "S") {

                        var response2 = await apiads.jobMuleInsertAds(
                            id_ads,
                        ).then(async (res2) => {

                            console.log("res from jobMuleInsertAds", res2);

                            console.log("azienda selezionata", that.ads.idcompany);


                            if (that.ads.idcompany == 7) // lc-service
                            {

                                var response3 = await apiads.jobMuleLCInsertAds(
                                    id_ads,
                                ).then((res3) => {

                                    that.$root.$children[0].showProgress = false;
                                    console.log("res from jobMuleLCInsertAds", res3);


                                    that.$swal({
                                        icon: "success",
                                        text: "Dati salvati correttamente",
                                        showConfirmButton: false,
                                        timer: 2000
                                    });

                                    setTimeout(() => {

                                        that.dialogMsg = false;
                                        that.setupButtons();

                                        router.push({
                                            path: "/annunci"
                                        });

                                    }, 200);


                                }).catch(err3 => {
                                    that.$root.$children[0].showProgress = false;
                                    console.log(err3);
                                    var msg = err3.response.data.Error;

                                    that.$swal({
                                        icon: "error",
                                        text: msg,
                                        showConfirmButton: false,
                                        timer: 8000
                                    });
                                    console.log("Errori", "Non è stato possibile eliminare i dati");
                                    console.log("response", response3);

                                }

                                );

                            }


                            if (that.ads.idcompany == 8) // ariall
                            {

                                var response4 = await apiads.jobMuleAriallInsertAds(
                                    id_ads,
                                ).then((res4) => {

                                    that.$root.$children[0].showProgress = false;
                                    console.log("res from jobMuleAriallInsertAds", res4);


                                    that.$swal({
                                        icon: "success",
                                        text: "Dati salvati correttamente",
                                        showConfirmButton: false,
                                        timer: 2000
                                    });

                                    setTimeout(() => {

                                        that.dialogMsg = false;
                                        that.setupButtons();

                                        router.push({
                                            path: "/annunci"
                                        });

                                    }, 200);


                                }).catch(err4 => {
                                    that.$root.$children[0].showProgress = false;
                                    console.log(err4);
                                    var msg = err4.response.data.Error;

                                    that.$swal({
                                        icon: "error",
                                        text: msg,
                                        showConfirmButton: false,
                                        timer: 8000
                                    });
                                    console.log("Errori", "Non è stato possibile eliminare i dati");
                                    console.log("response", response4);

                                }

                                );

                            }





                        }).catch(err2 => {
                            that.$root.$children[0].showProgress = false;
                            console.log(err2);
                            var msg = err2.response.data.Error;

                            that.$swal({
                                icon: "error",
                                text: msg,
                                showConfirmButton: false,
                                timer: 8000
                            });
                            console.log("Errori", "Non è stato possibile eliminare i dati");
                            console.log("response", response2);

                        }

                        );


                    }
                    else {

                        that.$root.$children[0].showProgress = false;

                        that.$swal({
                            icon: "success",
                            text: "Dati salvati correttamente",
                            showConfirmButton: false,
                            timer: 2000
                        });

                        setTimeout(() => {

                            that.dialogMsg = false;
                            that.setupButtons();

                            router.push({
                                path: "/annunci"
                            });

                        }, 200);
                    }




                }).catch(err => {
                    that.$root.$children[0].showProgress = false;
                    console.log(err);
                    var msg = err.response.data.Error;

                    that.$swal({
                        icon: "error",
                        text: msg,
                        showConfirmButton: false,
                        timer: 8000
                    });
                    console.log("Errori", "Non è stato possibile salvare i dati");
                    console.log("response", response);

                }


                );

            }

            if (id_rec > 0) {


                that.showSpinner = true;
                that.$root.$children[0].showProgress = true;

                var response8 = await apiads.updateAds(
                    that.ads,
                    v_token,
                    v_id_skills,
                    id_rec
                ).then(async (res) => {

                    console.log("res from updateAds", res);

                    if (that.ads.isurgent == "S") {

                        var response2 = await apiads.jobMuleInsertAds(
                            id_rec,
                        ).then(async (res2) => {

                            console.log("res from jobMuleInsertAds", res2);

                            console.log("azienda selezionata", that.ads.idcompany);


                            if (that.ads.idcompany == 7) // lc-service
                            {

                                var response3 = await apiads.jobMuleLCInsertAds(
                                    id_rec,
                                ).then((res3) => {

                                    that.$root.$children[0].showProgress = false;
                                    console.log("res from jobMuleLCInsertAds", res3);


                                    that.$swal({
                                        icon: "success",
                                        text: "Dati salvati correttamente",
                                        showConfirmButton: false,
                                        timer: 2000
                                    });

                                    setTimeout(() => {

                                        that.dialogMsg = false;
                                        that.setupButtons();

                                        router.push({
                                            path: "/annunci"
                                        });

                                    }, 200);


                                }).catch(err3 => {
                                    that.$root.$children[0].showProgress = false;
                                    console.log(err3);
                                    var msg = err3.response.data.Error;

                                    that.$swal({
                                        icon: "error",
                                        text: msg,
                                        showConfirmButton: false,
                                        timer: 8000
                                    });
                                    console.log("Errori", "Non è stato possibile eliminare i dati");
                                    console.log("response", response3);

                                }

                                );

                            }


                            if (that.ads.idcompany == 8) // ariall
                            {

                                var response4 = await apiads.jobMuleAriallInsertAds(
                                    id_rec,
                                ).then((res4) => {

                                    that.$root.$children[0].showProgress = false;
                                    console.log("res from jobMuleAriallInsertAds", res4);


                                    that.$swal({
                                        icon: "success",
                                        text: "Dati salvati correttamente",
                                        showConfirmButton: false,
                                        timer: 2000
                                    });

                                    setTimeout(() => {

                                        that.dialogMsg = false;
                                        that.setupButtons();

                                        router.push({
                                            path: "/annunci"
                                        });

                                    }, 200);


                                }).catch(err4 => {
                                    that.$root.$children[0].showProgress = false;
                                    console.log(err4);
                                    var msg = err4.response.data.Error;

                                    that.$swal({
                                        icon: "error",
                                        text: msg,
                                        showConfirmButton: false,
                                        timer: 8000
                                    });
                                    console.log("Errori", "Non è stato possibile eliminare i dati");
                                    console.log("response", response4);

                                }

                                );

                            }





                        }).catch(err2 => {
                            that.$root.$children[0].showProgress = false;
                            console.log(err2);
                            var msg = err2.response.data.Error;

                            that.$swal({
                                icon: "error",
                                text: msg,
                                showConfirmButton: false,
                                timer: 8000
                            });
                            console.log("Errori", "Non è stato possibile eliminare i dati");
                            console.log("response", response2);

                        }

                        );


                    }
                    else {

                        that.$root.$children[0].showProgress = false;

                        that.$swal({
                            icon: "success",
                            text: "Dati salvati correttamente",
                            showConfirmButton: false,
                            timer: 2000
                        });

                        setTimeout(() => {

                            that.dialogMsg = false;
                            that.setupButtons();

                            router.push({
                                path: "/annunci"
                            });

                        }, 200);
                    }



                }).catch(err => {
                    that.$root.$children[0].showProgress = false;
                    console.log(err);
                    var msg = err.response.data.Error;

                    that.$swal({
                        icon: "error",
                        text: msg,
                        showConfirmButton: false,
                        timer: 8000
                    });
                    console.log("Errori", "Non è stato possibile salvare i dati");
                    console.log("response", response8);

                }


                );




            }

        },

        syncPagamento: async function () {

            var v_token = window.$cookies.get("token");

            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apipagamento.getPagamento(
                that.$route.params.id, v_token

            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from getPagamento", res);

                try {

                    this.pagamento = res.data.Result;

                    this.importoRimanente = res.data.Result.importo_rimanente;

                    if (res.data.Result.is_child_pag == "N") // pagamento master
                    {

                        this.pagamento.importo_pagato = null;

                        var today = new Date();

                        var sDate = today.getFullYear() + "-" + (today.getMonth() + 1).toString().padStart(2, 0) + "-" + today.getDate().toString().padStart(2, 0);

                        console.log("DATE: ", sDate);

                        this.pagamento.data_pagamento = sDate; // default data corrente

                    }

                    if (res.data.Result.is_child_pag == "S") // pagamento child
                    {

                        this.disField = true;

                    }

                    if (res.data.Result.importo != null) {

                        this.$root.$children[0].setFieldActive("#d_importo");

                    }

                    if (res.data.Result.importo_pagato != null) {

                        this.$root.$children[0].setFieldActive("#d_pagato");

                    }

                    if (res.data.Result.importo_rimanente != null) {

                        this.$root.$children[0].setFieldActive("#d_importo_rimanente");

                    }

                    this.valoreDaPagare = res.data.Result.importo;

                    this.valoreRimanente = res.data.Result.importo_rimanente;

                    this.disFieldRim = true;

                    var allegato_salvato = res.data.Result.allegato_salvato;

                    if (allegato_salvato) {

                        var elements = allegato_salvato.split(".");

                        console.log("ELEMENTS: ", elements);

                        var txt_image = "";
                        if (elements[1] == "pdf") {

                            txt_image = this.getUrlDomain("public/documents/pdf_extension.png");

                        } else {

                            txt_image = this.getUrlDomain("public/documents/" + allegato_salvato);

                        }

                        setTimeout(() => {

                            $(".dropify-render img").attr("src", txt_image);
                            $(".dropify-wrapper").addClass("has-preview");
                            $(".dropify-preview").show("slow");

                        }, 100);

                    }

                } catch (error) {
                    console.log(error);
                }

            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile caricare i dati");
                console.log("response", response);

            }

            );

        },

        loadTipologie: async function () {

            var v_token = window.$cookies.get("token");

            var that = this;

            that.showSpinner = true;
            that.$root.$children[0].showProgress = true;

            var response = await apipagamento.getTipologie(
                v_token
            ).then((res) => {

                that.$root.$children[0].showProgress = false;
                console.log("res from getTipologie", res);

                try {

                    this.tipologie = res.data.Result;

                } catch (error) {
                    console.log(error);
                }

            }).catch(err => {
                that.$root.$children[0].showProgress = false;
                console.log(err);
                var msg = err.response.data.Error;

                that.$swal({
                    icon: "error",
                    text: msg,
                    showConfirmButton: false,
                    timer: 8000
                });
                console.log("ERrori", "Non è stato possibile caricare i dati");
                console.log("response", response);

            }

            );

        }

    }

})
</script>

<style>
#btnSelDetSkillsEditAds {
    width: 15px;
    transform: translate(455px, -52px);
    cursor: pointer;
}


#btnSelComuneEditAds {
    width: 15px;
    transform: translate(455px, -52px);
    cursor: pointer;
}

#btnSelProvinciaEditAds {
    width: 15px;
    transform: translate(455px, -52px);
    cursor: pointer;
}


#btnSelRegioneEditAds {
    width: 15px;
    transform: translate(455px, -52px);
    cursor: pointer;
}


#btnSelSottoCategoriaEditAds {
    width: 15px;
    transform: translate(455px, -52px);
    cursor: pointer;
}


#btnSelGiornataLavoroTipoEditAds {
    width: 15px;
    transform: translate(455px, -52px);
    cursor: pointer;
}


#btnSelStudiMinimiEditAds {
    width: 15px;
    transform: translate(455px, -52px);
    cursor: pointer;
}

#btnSelTipoContrattoEditAds {
    width: 15px;
    transform: translate(455px, -52px);
    cursor: pointer;
}


#btnSelAziendaEditAds {
    width: 15px;
    transform: translate(455px, -52px);
    cursor: pointer;
}



#btnSelCategoriaEditAds {
    width: 15px;
    transform: translate(455px, -52px);
    cursor: pointer;
}


#btnSelScopoEditAds {
    width: 15px;
    transform: translate(455px, -52px);
    cursor: pointer;
}


.edit_annuncio .select-disabled,
.item-select-disabled ion-label {
    opacity: 1;
}




.w-container {
    width: 500px;
    padding: 0px;
    z-index: 3;
}

.v-form {
    margin-top: 41px;
}

.mainTitle {
    padding: 20px !important;
    position: fixed;
    min-width: 500px;
    z-index: 1;
    top: 67px;
    border: 1px solid black;
}

.dropify-clear {
    border: 0px !important;
    margin-top: -7px !important;
    margin-right: -7px !important;
}

.align_close_sheet {
    top: 23px !important
}


.headerSheetAziende {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}

.headerSheetAziendeClienti {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}


.headerSheetClienti {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}

.headerSheetTipologie {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}

.headerSheetDipartimento {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}

.headerSheetUtentiAssociati {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}

.headerSheetPianoOrario {
    position: fixed;
    z-index: 2;
    min-width: 100vw;
    background: white;
}


.closeSheet {
    position: absolute;
    right: 10px;
    top: 26px;
    z-index: 2;
}

.itemAzienda {
    margin-left: 15px;
}

.itemAziendaCliente {
    margin-left: 15px;
}

.itemCliente {
    margin-left: 15px;
}

.itemDipartimento {
    margin-left: 15px;
}

.itemTipologia {
    margin-left: 15px;
}

.itemUtenteAssociato {
    margin-left: 15px;
}


.itemPianoOrarioCodice {
    margin-left: 15px;
}

.itemPianoOrarioDescrizione {
    margin-left: 15px;
}



.v-application .text-center {

    overflow: auto;
}

.dropify-clear img {
    /* display: none; */
    width: 20px !important;
}

.dropify-wrapper {
    height: 236px !important;
    width: 465px !important;
    margin-bottom: 20px;
    margin-left: 10px;
}

.img_copy {
    cursor: pointer;
}

.img_copy_rim {
    cursor: pointer;
}


.edit_annuncio .v-label {
    font-size: 11px !important;
    color: black !important;
    font-weight: bold !important;
}


.edit_annuncio .v-input {
    font-size: 11px !important;
    padding: 10px !important;
    color: black !important;
    font-weight: bold !important;
}

.edit_annuncio ion-select {
    font-size: 11px !important;
    color: black !important;
    font-weight: bold !important;
}







.cont_piano_orario #myTablePianoOrario {
    margin-right: 3px;
}

.cont_piano_orario table.dataTable.dtr-inline.collapsed>tbody>tr>td.dtr-control,
.cont_piano_orario table.dataTable.dtr-inline.collapsed>tbody>tr>th.dtr-control {
    padding-left: 25px !important;
}

.cont_piano_orario th {
    padding-left: 5px !important;
}

.cont_piano_orario ion-datetime.dateBook {
    margin-left: 16px;
}

.cont_piano_orario .table-responsive {
    padding: 0px;
    min-width: 90vw;
    max-width: 100vw;
}

.cont_piano_orario #myTablePianoOrario_filter {
    position: fixed;
    left: 0px;
    min-width: 100%;
    z-index: 3;
}

.cont_piano_orario div.dataTables_wrapper div.dataTables_filter input {
    /* margin-top:5px!important */
}

.cl-date {
    font-size: 10px;
    color: gray;
}

.cont_piano_orario #myTablePianoOrario_wrapper {
    padding-top: 0px;
}

.text_title {
    background-color: #ff00a3;
    color: white;
    font-weight: bold;
    padding-top: 4px;
    padding-bottom: 4px;
    padding-left: 0px;
    font-size: 10px;
    min-width: 82vw
}

.cont_piano_orario .cl_active {
    display: inline-flex;
    align-items: center;
    min-width: 100%;
    justify-content: center;
}


.first_column_piano_orario {
    width: 4%;
    text-align: left;
}

.second_column_piano_orario {
    width: 32%;
    text-align: left;
    font-weight: bold;
    font-size: 10px;
}

.third_column_piano_orario {
    width: 32%;
    text-align: left;
    margin-left: -6px;
    font-weight: bold;
    font-size: 10px;
}

.fourth_column_piano_orario {
    margin-left: -5px;
    font-weight: bold;
    font-size: 10px;
}

.cl-del-date-nascita {
    width: 15px;
    transform: translate(413px, -54px);
    cursor: pointer;
}

.cl-del-inizio-rapporto {
    width: 15px;
    cursor: pointer;
    transform: translate(415px, -54px);
}

.cl-del-fine-rapporto {
    width: 15px;
    cursor: pointer;
    transform: translate(415px, -54px);
}


.height-panel-asset {
    height: 381px !important
}

.cl-del-date {
    width: 15px;
    transform: translate(448px, -54px);
    cursor: pointer;
}

.cl-del-date-expired {
    width: 15px;
    transform: translate(448px, -54px);
    cursor: pointer;
}

.edit_annuncio .v-input.theme--light.v-input--selection-controls.v-input--checkbox {
    margin-top: -14px !important;
    margin-bottom: -19px !important;
}

.cl-checkbox i {
    font-size: 13px !important;
    transform: translateY(0px);
}

.cl-descrizione {
    width: 470px !important;
    height: 400px !important
}


@media screen and (max-width: 768px) {

    .align_close_sheet {
        top: 18px !important
    }

    .v-form {

        padding-top: 45px;
        padding-left: 16px;
        padding-right: 16px;
    }

    .w-container {
        width: 100vw;
        padding: initial;
        padding: inherit;
    }

    .mainTitle {
        padding: 20px !important;
        position: fixed;
        min-width: 100vw;
        left: 0;
        z-index: 1;
        top: 57px;
    }

    .dropify-clear {
        border: 0px !important;
        margin-bottom: -26px !important;
    }

    .cont_piano_orario .cl_active {
        display: contents;
        align-items: center;
        justify-content: flex-start;
        text-align: center;
    }

    .cont_piano_orario #myTablePianoOrario {
        /* margin-top:54px; */
    }

    .cont_piano_orario #myTablePianoOrario_filter {
        top: 56px;
        position: fixed;

    }


    .first_column_piano_orario {
        width: 19%;
        text-align: left;
    }

    .second_column_piano_orario {
        width: 28%;
        text-align: left;
        font-weight: bold;
        font-size: 10px;
    }

    .third_column_piano_orario {
        width: 28%;
        text-align: left;
        margin-left: -6px;
        font-weight: bold;
        font-size: 10px;
    }

    .fourth_column_piano_orario {
        margin-left: -5px;
        font-weight: bold;
        font-size: 10px;
    }


    .cl-del-date {
        transform: translate(320px, -56px);
    }

    .height-panel-asset {
        height: 381px !important
    }

    .cl-del-date-expired {
        transform: translate(320px, -54px);
    }


}


@media screen and (max-width: 1024px) {


    .cont_piano_orario #myTablePianoOrario {
        max-width: 95vw !important;
        margin-right: 0px;
        min-width: 95vw !important;
        position: relative;
        width: 95vw !important;

    }

    .cont_piano_orario #myTablePianoOrario_filter {
        top: 56px;
        position: fixed;

    }

    .cont_piano_orario .table-responsive {
        padding: 0px;
        min-width: 95vw !important;
        max-width: 95vw !important;
        left: 0px;
        position: fixed;

    }

    .cont_piano_orario #myTablePianoOrario_wrapper {
        min-width: initial;
        min-width: 95vw !important;
        max-width: 95vw !important;
        width: 95vw !important;
        overflow-x: hidden !important;
    }

    .cont_piano_orario .cl_num {
        margin-left: 16px !important;
    }





}
</style>
